(function () {
  "use strict";

  var VERSION = "36.2.11";
  if (
    window.PuzzlePupQuizV17 &&
    window.PuzzlePupQuizV17.version === VERSION &&
    window.PuzzlePupQuizV17.initialized
  ) {
    return;
  }

  var SHOPIFY_FILES_BASE =
    "https://cdn.shopify.com/s/files/1/0723/3798/1580/files/";
  var DEFAULT_ASSET_BASE = SHOPIFY_FILES_BASE;

  function currentScriptAssetBase() {
    try {
      var source = String(
        document.currentScript && document.currentScript.src
          ? document.currentScript.src
          : "",
      );
      if (!source) return "";
      var cleanSource = source.split("#")[0].split("?")[0];
      var lastSlash = cleanSource.lastIndexOf("/");
      return lastSlash >= 0 ? cleanSource.slice(0, lastSlash + 1) : "";
    } catch (error) {
      return "";
    }
  }

  var assetBase = String(
    window.PP_FUNNEL_ASSET_BASE ||
      currentScriptAssetBase() ||
      DEFAULT_ASSET_BASE,
  );
  if (assetBase.charAt(assetBase.length - 1) !== "/") assetBase += "/";

  function asset(file) {
    return assetBase + file;
  }

  function filesAsset(file) {
    return SHOPIFY_FILES_BASE + file;
  }

  function resizedImageUrl(url, width) {
    var source = String(url || "");
    var targetWidth = Math.max(1, Math.round(Number(width) || 1));
    if (/([?&])width=\d+/.test(source)) {
      return source.replace(/([?&])width=\d+/, "$1width=" + targetWidth);
    }
    return source + (source.indexOf("?") >= 0 ? "&" : "?") + "width=" + targetWidth;
  }

  function responsiveImageAttributes(url, widths, sizes) {
    var candidates = widths.map(function (width) {
      return resizedImageUrl(url, width) + " " + width + "w";
    });
    return (
      'src="' +
      escapeAttribute(resizedImageUrl(url, widths[widths.length - 1])) +
      '" srcset="' +
      escapeAttribute(candidates.join(", ")) +
      '" sizes="' +
      escapeAttribute(sizes) +
      '"'
    );
  }

  var CONFIG = Object.freeze({
    quizId: "dog_wellness_match",
    quizVersion: VERSION,
    oneTimePriceCents: 3499,
    compareAtPriceCents: 3499,
    subscriptionDiscountPercent: 15,
    klaviyoPublicKey: "R4gpjj",
    klaviyoListId: "TGj2yJ",
    klaviyoEvent: "Completed Dog Match Quiz",
  });

  var SNUFFLE_MAT = Object.freeze({
    key: "snuffle_mat",
    name: "PuzzlePup Snuffle Mat",
    url: "/products/puzzlepup-snuffle-mat",
    variantId: 46206663098508,
    catalogPriceCents: 3999,
    offerPriceCents: 1500,
    image: "https://www.puzzlepupco.com/cdn/shop/files/smartmat-original-product.jpg?v=1791148136",
  });

  var PRODUCTS = Object.freeze({
    A: Object.freeze({
      key: "A",
      name: "Allergy Soft Chews",
      url: "/products/puzzlepup-allergy-soft-chews",
      variantId: 45943769956492,
      badge: "Daily seasonal skin care",
      heroImg: "https://cdn.shopify.com/s/files/1/0723/3798/1580/files/puzzlepup-allergy-soft-chews-primary-cover-1x1_fe456b77-638c-4b18-b7a0-a8a528e8cc2a.png?v=1785208821",
      heroAlt:
        "PuzzlePup Allergy Soft Chews jar",
      productImg: filesAsset(
        "puzzlepup-allergy-soft-chews-primary-cover-1x1_fe456b77-638c-4b18-b7a0-a8a528e8cc2a.png?v=1785208821&width=1000",
      ),
      summary:
        "Daily soft chews for seasonal skin care.",
      outcome:
        "Daily soft chews for seasonal skin care.",
    }),
    J: Object.freeze({
      key: "J",
      name: "Hip & Joint Soft Chews",
      url: "/products/puzzlepup-hip-and-joint-chews-enhanced-dog-health-and-mobility",
      variantId: 45943804461196,
      badge: "Glucosamine, MSM and more",
      heroImg: "https://cdn.shopify.com/s/files/1/0723/3798/1580/files/puzzlepup-hip-joint-soft-chews-primary-cover-1x1_a0430d9a-1311-467f-8179-0f5c75762b7b.png?v=1785208839",
      heroAlt:
        "PuzzlePup Hip and Joint Soft Chews jar",
      productImg: filesAsset(
        "puzzlepup-hip-joint-soft-chews-primary-cover-1x1_a0430d9a-1311-467f-8179-0f5c75762b7b.png?v=1785208839&width=1000",
      ),
      summary:
        "Glucosamine, chondroitin, MSM, and Boswellia in a daily soft chew.",
      outcome:
        "Daily soft chews for joint health and comfortable movement.",
    }),
    S: Object.freeze({
      key: "S",
      name: "Skin & Coat Soft Chews",
      url: "/products/puzzlepup-skin-coat-soft-chews",
      variantId: 45943912857740,
      badge: "Omega-3s and biotin in a soft chew",
      heroImg: "https://cdn.shopify.com/s/files/1/0723/3798/1580/files/puzzlepup-skin-coat-soft-chews-primary-cover-1x1_8a5c71d0-a269-4c79-ae81-28a818d3cdf3.png?v=1785208859",
      heroAlt:
        "PuzzlePup Skin and Coat Soft Chews jar",
      productImg: filesAsset(
        "puzzlepup-skin-coat-soft-chews-primary-cover-1x1_8a5c71d0-a269-4c79-ae81-28a818d3cdf3.png?v=1785208859&width=1000",
      ),
      summary:
        "Fish oil, flaxseed oil, and biotin in a soft chew for skin-and-coat nutrition.",
      outcome:
        "Daily soft chews for healthy skin and a shiny coat.",
    }),
  });

  var FUNNEL_IMAGES = Object.freeze({
    A: Object.freeze({
      start: "https://cdn.shopify.com/s/files/1/0723/3798/1580/files/puzzlepup-allergy-soft-chews-primary-cover-1x1_fe456b77-638c-4b18-b7a0-a8a528e8cc2a.png?v=1785208821",
      transitions: Object.freeze(["https://cdn.shopify.com/s/files/1/0723/3798/1580/files/al-04-ing_428d4a2a-1238-420e-9adc-23f36a341874.webp?v=1785126819","https://cdn.shopify.com/s/files/1/0723/3798/1580/files/al-09-label_c3629ec5-e0b2-4fd9-80da-aa5c11397dbc.webp?v=1785126819"]),
      result: "https://cdn.shopify.com/s/files/1/0723/3798/1580/files/puzzlepup-allergy-soft-chews-primary-cover-1x1_fe456b77-638c-4b18-b7a0-a8a528e8cc2a.png?v=1785208821",
      carousel: Object.freeze(["https://cdn.shopify.com/s/files/1/0723/3798/1580/files/puzzlepup-allergy-soft-chews-primary-cover-1x1_fe456b77-638c-4b18-b7a0-a8a528e8cc2a.png?v=1785208821","https://cdn.shopify.com/s/files/1/0723/3798/1580/files/al-04-ing_428d4a2a-1238-420e-9adc-23f36a341874.webp?v=1785126819","https://cdn.shopify.com/s/files/1/0723/3798/1580/files/al-09-label_c3629ec5-e0b2-4fd9-80da-aa5c11397dbc.webp?v=1785126819","https://cdn.shopify.com/s/files/1/0723/3798/1580/files/al-07-qual_5a82789f-9820-4e82-8ac1-8729b64e45b8.webp?v=1791163476"])
    }),
    J: Object.freeze({
      start: "https://cdn.shopify.com/s/files/1/0723/3798/1580/files/puzzlepup-hip-joint-soft-chews-primary-cover-1x1_a0430d9a-1311-467f-8179-0f5c75762b7b.png?v=1785208839",
      transitions: Object.freeze(["https://cdn.shopify.com/s/files/1/0723/3798/1580/files/02-04_Key_Ingredients_Exact_Amounts_9993abdb-3f08-4d88-867c-ed6e3f32c655.webp?v=1785126291","https://cdn.shopify.com/s/files/1/0723/3798/1580/files/03-09_Front_Back_Label_0c1c0ffd-4146-42e2-a71d-de6cf281b6e7.webp?v=1785126291"]),
      result: "https://cdn.shopify.com/s/files/1/0723/3798/1580/files/puzzlepup-hip-joint-soft-chews-primary-cover-1x1_a0430d9a-1311-467f-8179-0f5c75762b7b.png?v=1785208839",
      carousel: Object.freeze(["https://cdn.shopify.com/s/files/1/0723/3798/1580/files/puzzlepup-hip-joint-soft-chews-primary-cover-1x1_a0430d9a-1311-467f-8179-0f5c75762b7b.png?v=1785208839","https://cdn.shopify.com/s/files/1/0723/3798/1580/files/02-04_Key_Ingredients_Exact_Amounts_9993abdb-3f08-4d88-867c-ed6e3f32c655.webp?v=1785126291","https://cdn.shopify.com/s/files/1/0723/3798/1580/files/03-09_Front_Back_Label_0c1c0ffd-4146-42e2-a71d-de6cf281b6e7.webp?v=1785126291","https://cdn.shopify.com/s/files/1/0723/3798/1580/files/05-07_Quality_Manufacturing_Proof_aab2a4ec-11cd-4c75-90a8-e1924aaf6414.webp?v=1791163476"])
    }),
    S: Object.freeze({
      start: "https://cdn.shopify.com/s/files/1/0723/3798/1580/files/puzzlepup-skin-coat-soft-chews-primary-cover-1x1_8a5c71d0-a269-4c79-ae81-28a818d3cdf3.png?v=1785208859",
      transitions: Object.freeze(["https://cdn.shopify.com/s/files/1/0723/3798/1580/files/sc-04-ing_a0804b62-9f95-4762-8acf-8435f3f3d66d.webp?v=1791163476","https://cdn.shopify.com/s/files/1/0723/3798/1580/files/sc-09-label_4d62b7ba-fb7b-4134-88b6-59b591641535.webp?v=1785126902"]),
      result: "https://cdn.shopify.com/s/files/1/0723/3798/1580/files/puzzlepup-skin-coat-soft-chews-primary-cover-1x1_8a5c71d0-a269-4c79-ae81-28a818d3cdf3.png?v=1785208859",
      carousel: Object.freeze(["https://cdn.shopify.com/s/files/1/0723/3798/1580/files/puzzlepup-skin-coat-soft-chews-primary-cover-1x1_8a5c71d0-a269-4c79-ae81-28a818d3cdf3.png?v=1785208859","https://cdn.shopify.com/s/files/1/0723/3798/1580/files/sc-04-ing_a0804b62-9f95-4762-8acf-8435f3f3d66d.webp?v=1791163476","https://cdn.shopify.com/s/files/1/0723/3798/1580/files/sc-09-label_4d62b7ba-fb7b-4134-88b6-59b591641535.webp?v=1785126902","https://cdn.shopify.com/s/files/1/0723/3798/1580/files/sc-07-qual_68d60798-eaa4-4ee9-b3a5-4d4a1e14a4d6.webp?v=1791163477"])
    })
  });

  var PRODUCT_VIDEOS = Object.freeze({
    A: Object.freeze([
      Object.freeze({
        src: asset("pp-video-allergy-chew.mp4"),
        poster: "https://cdn.shopify.com/s/files/1/0723/3798/1580/files/puzzlepup-video-poster-allergy-chew-9x16-20260901.png?v=1788314663",
        caption: "See the daily Allergy chew up close.",
      }),
      Object.freeze({
        src: asset("pp-video-allergy-ugc-v2.mp4"),
        poster: "https://cdn.shopify.com/s/files/1/0723/3798/1580/files/puzzlepup-video-poster-allergy-ugc-9x16-20260901.png?v=1788314676",
        caption: "An Allergy-chew demonstration.",
      }),
    ]),
    J: Object.freeze([
      Object.freeze({
        src: asset("pp-video-joint-chew.mp4"),
        poster: "https://cdn.shopify.com/s/files/1/0723/3798/1580/files/puzzlepup-video-poster-joint-chew-9x16-20260901.png?v=1788314646",
        caption: "One easy Hip & Joint chew at bowl time.",
      }),
      Object.freeze({
        src: asset("pp-video-joint-cgi.mp4"),
        poster: "https://cdn.shopify.com/s/files/1/0723/3798/1580/files/puzzlepup-video-poster-joint-story-9x16-20260901.png?v=1788314671",
        caption: "See the Hip & Joint formula up close.",
      }),
    ]),
    S: Object.freeze([
      Object.freeze({
        src: asset("pp-video-skin-chews.mp4"),
        poster: "https://cdn.shopify.com/s/files/1/0723/3798/1580/files/puzzlepup-video-poster-skin-chews-9x16-20260901.png?v=1788314657",
        caption: "Two Skin & Coat chews, ready for your dog’s day.",
      }),
      Object.freeze({
        src: asset("pp-video-skin-normie.mp4"),
        poster: "https://cdn.shopify.com/s/files/1/0723/3798/1580/files/puzzlepup-video-poster-skin-normie-9x16-20260901.png?v=1788314695",
        caption: "Meet Normie and the PuzzlePup supplement lineup.",
      }),
    ]),
  });

  var REFILL_PLANS = Object.freeze({
    small: Object.freeze({
      min: 1,
      max: 25,
      chewsPerDay: 1,
      quantity: 1,
      sellingPlanId: 3470819468,
      cadence: "every 2 months",
      cadenceShort: "2 months",
      jarDays: 60,
      deliveryDays: 60,
      summary: "1 jar every 2 months",
    }),
    medium: Object.freeze({
      min: 26,
      max: 50,
      chewsPerDay: 2,
      quantity: 1,
      sellingPlanId: 3320578188,
      cadence: "every month",
      cadenceShort: "month",
      jarDays: 30,
      deliveryDays: 30,
      summary: "1 jar every month",
    }),
    large: Object.freeze({
      min: 51,
      max: 250,
      chewsPerDay: 3,
      quantity: 1,
      sellingPlanId: 3320578188,
      cadence: "every month",
      cadenceShort: "month",
      jarDays: 20,
      deliveryDays: 20,
      summary: "1 jar · 20 days total",
    }),
  });

  var GOALS = Object.freeze({
    allergy: Object.freeze({
      key: "allergy",
      category: "A",
      icon: "🐾",
      label: "Quiet the itch concert",
      quizLabel: "itch fix",
      detailPrompt: "Pick the clue making dog-mom detective mode kick in.",
      introTitle: "Let’s solve the scratch-and-lick mystery",
      introCopy:
        "Eight quick taps. One clear jar. Zero guesswork. Pick any two one-time jars for $49.99 and get one round Classic Smart Snuffle Mat free while gift supplies last.",
      heroAlt: "PuzzlePup Allergy Soft Chews jar",
    }),
    joint: Object.freeze({
      key: "joint",
      category: "J",
      icon: "🦴",
      label: "Bring back the couch launch",
      quizLabel: "couch-launch",
      detailPrompt: "Pick the move that suddenly looks like a big decision.",
      introTitle: "Let’s make couch launches look easy again",
      introCopy:
        "Eight quick taps. One clear jar. Zero guesswork. Pick any two one-time jars for $49.99 and get one round Classic Smart Snuffle Mat free while gift supplies last.",
      heroAlt: "PuzzlePup Hip and Joint Soft Chews jar",
    }),
    skin: Object.freeze({
      key: "skin",
      category: "S",
      icon: "✨",
      label: "Stop the fur tumbleweeds",
      quizLabel: "fur-glow",
      detailPrompt: "Pick the clue currently decorating your floor or leggings.",
      introTitle: "Let’s send fur tumbleweeds packing",
      introCopy:
        "Eight quick taps. One clear jar. Zero guesswork. Pick any two one-time jars for $49.99 and get one round Classic Smart Snuffle Mat free while gift supplies last.",
      heroAlt: "PuzzlePup Skin and Coat Soft Chews jar",
    }),
    wellness: Object.freeze({
      key: "wellness",
      category: null,
      icon: "💙",
      label: "Fix the biggest dog-mom ‘ugh’",
      quizLabel: "bestie",
      detailPrompt: "Pick the one problem stealing your pup’s sparkle first.",
      introTitle: "What’s bugging your bestie?",
      introCopy:
        "Eight quick taps. One clear jar. Zero guesswork. Pick any two one-time jars for $49.99 and get one round Classic Smart Snuffle Mat free while gift supplies last.",
      heroAlt: "PuzzlePup Allergy, Hip and Joint, and Skin and Coat Soft Chews jars",
    }),
  });

  var DETAIL_OPTIONS = Object.freeze({
    allergy: Object.freeze([
      Object.freeze({
        id: "itch_scratching",
        label: "The scratch, rub, lick encore",
        icon: "🐾",
        category: "A",
      }),
      Object.freeze({
        id: "itch_ears",
        label: "The head-shake remix",
        icon: "👂",
        category: "A",
      }),
    ]),
    joint: Object.freeze([
      Object.freeze({
        id: "joint_stiffness",
        label: "The slow-motion post-nap rise",
        icon: "🐢",
        category: "J",
      }),
      Object.freeze({
        id: "joint_stairs",
        label: "The ‘do I have to jump?’ stare",
        icon: "🪜",
        category: "J",
      }),
    ]),
    skin: Object.freeze([
      Object.freeze({
        id: "skin_shedding",
        label: "Fur tumbleweeds and missing shine",
        icon: "🧹",
        category: "S",
      }),
      Object.freeze({
        id: "skin_flaky",
        label: "Flakes showing up uninvited",
        icon: "❄️",
        category: "S",
      }),
    ]),
    wellness: Object.freeze([
      Object.freeze({
        id: "wellness_allergy",
        label: "Scratch, paw-lick, or head-shake drama",
        icon: "🐾",
        category: "A",
      }),
      Object.freeze({
        id: "wellness_joint",
        label: "Slow starts, stair pauses, or skipped jumps",
        icon: "🦴",
        category: "J",
      }),
      Object.freeze({
        id: "wellness_skin",
        label: "Fur tumbleweeds, flakes, or a dull coat",
        icon: "✨",
        category: "S",
      }),
    ]),
  });

  var FORMULAS = Object.freeze({
    A: Object.freeze({
      matchHeadline: "Yep—this is the itch jar, not a generic coat chew.",
      signalCopy:
        "The scratch, lick, rub, repeat pattern is the clue. This jar is made for seasonal itch—not stiff joints or a dull coat.",
      systemCopy:
        "Compare the label’s amounts of quercetin, turmeric, postbiotic ingredients, and ashwagandha before choosing this seasonal wellness formula.",
      differenceCopy:
        "Hip & Joint is for stiff moves. Skin & Coat is for flakes, shedding, and shine. Allergy Soft Chews match the scratch-and-lick clue you picked.",
      actionCopy:
        "Start with the chew count shown for your dog’s size. Then watch the exact clue you picked—because your phone camera and leggings remember more than guesswork does.",
      amountBasis: "What the label lists in 2 soft chews (6 g)",
      benefits: Object.freeze([
        "Daily seasonal skin care",
        "With quercetin and postbiotic ingredients",
        "Simple daily directions",
        "60 soft chews per jar",
      ]),
      ingredients: Object.freeze([
        Object.freeze({
          name: "Turmeric root powder",
          amount: "100 mg",
          reason: "Turmeric amount shown on the formula label",
        }),
        Object.freeze({
          name: "Quercetin",
          amount: "75 mg",
          reason: "Quercetin amount shown on the formula label",
        }),
        Object.freeze({
          name: "Postbiotic",
          amount: "250 mg",
          reason: "Postbiotic amount shown on the formula label",
        }),
        Object.freeze({
          name: "Ashwagandha",
          amount: "100 mg",
          reason: "Ashwagandha amount shown on the formula label",
        }),
      ]),
      faq: Object.freeze([
        Object.freeze({
          q: "Will this replace allergy medicine?",
          a: "Nope—this is a daily chew, not allergy medicine. Keep giving anything your veterinarian prescribed exactly as directed. If your pup uses both, keep your veterinarian in the loop.",
        }),
      ]),
    }),
    J: Object.freeze({
      matchHeadline: "Yep—this is the movement jar, not a random multivitamin.",
      signalCopy:
        "Slow starts, stair pauses, and the suspicious couch stare are the clue. This jar is made for movement—not itchy skin or a dull coat.",
      systemCopy:
        "Four featured ingredients—glucosamine, chondroitin, MSM, and Boswellia—with their amounts clearly listed on the label.",
      differenceCopy:
        "Allergy Soft Chews are for the itch loop. Skin & Coat is for flakes and fur tumbleweeds. Hip & Joint matches the stiff-movement clue you picked.",
      actionCopy:
        "Start with the chew count shown for your dog’s size. Then watch the moments that matter: getting up, stairs, walks, and play. Your couch will know first.",
      amountBasis: "What the label lists in 2 soft chews (6 g)",
      benefits: Object.freeze([
        "With glucosamine and chondroitin",
        "Also includes MSM and Boswellia",
        "Easy-to-give daily soft chews",
        "60 soft chews per jar",
      ]),
      ingredients: Object.freeze([
        Object.freeze({
          name: "Glucosamine",
          amount: "250 mg",
          reason: "Glucosamine amount shown on the formula label",
        }),
        Object.freeze({
          name: "Chondroitin",
          amount: "90 mg",
          reason: "Chondroitin amount shown on the formula label",
        }),
        Object.freeze({
          name: "MSM",
          amount: "250 mg",
          reason: "MSM amount shown on the formula label",
        }),
        Object.freeze({
          name: "Boswellia",
          amount: "100 mg",
          reason: "Boswellia amount shown on the formula label",
        }),
      ]),
      faq: Object.freeze([
        Object.freeze({
          q: "Is this only for senior dogs?",
          a: "Nope. This chew can also fit active, large, or working adult dogs when stiff starts, stairs, or play begin looking harder.",
        }),
      ]),
    }),
    S: Object.freeze({
      matchHeadline: "Yep—this is the fur-glow jar, not the allergy jar.",
      signalCopy:
        "Fur tumbleweeds, flakes, and a coat that lost its glow are the clue. This jar is made for skin and fur—not stiff joints or seasonal itch.",
      systemCopy:
        "Fish oil, flaxseed oil, and biotin in a chew with a printed guaranteed analysis, including omega-3, EPA, and DHA amounts.",
      differenceCopy:
        "Allergy Soft Chews are for the itch loop. Hip & Joint is for stiff moves. Skin & Coat matches the flakes, shedding, or dull-fur clue you picked.",
      actionCopy:
        "Start with the chew count shown for your dog’s size. Then track the clues your vacuum already knows: shedding, flakes, softness, and shine.",
      amountBasis: "What the label guarantees in 2 soft chews",
      benefits: Object.freeze([
        "Fish oil and flaxseed oil in a soft chew",
        "With biotin for skin and coat care",
        "Simple daily directions",
        "60 soft chews per jar",
      ]),
      ingredients: Object.freeze([
        Object.freeze({
          name: "Omega-3 fats",
          amount: "At least 5%",
          reason: "The jar contains at least this amount",
        }),
        Object.freeze({
          name: "EPA (an omega-3 fat)",
          amount: "At least 1.25%",
          reason: "A type of omega-3 fat",
        }),
        Object.freeze({
          name: "DHA (another omega-3 fat)",
          amount: "At least 0.8%",
          reason: "A type of omega-3 fat",
        }),
        Object.freeze({
          name: "Biotin",
          amount: "At least 0.2 mg",
          reason: "The jar contains at least this amount",
        }),
      ]),
      faq: Object.freeze([
        Object.freeze({
          q: "Will this stop all shedding?",
          a: "No. This product does not promise to stop shedding. Compare its ingredients and label directions with your dog’s needs.",
        }),
      ]),
    }),
  });

  var PROOF = Object.freeze({
    A: Object.freeze({"fact":"Allergy Soft Chews contain postbiotics, quercetin, turmeric root and ashwagandha.","detail":"See the full ingredients and how many chews to give.","link":"/products/puzzlepup-allergy-soft-chews#pp-expert","label":"Read the full product label"}),
    J: Object.freeze({"fact":"Hip & Joint Soft Chews contain glucosamine, MSM, chondroitin, Boswellia and turmeric root.","detail":"See the full ingredients and how many chews to give.","link":"/products/puzzlepup-hip-and-joint-chews-enhanced-dog-health-and-mobility#pp-expert","label":"Read the full product label"}),
    S: Object.freeze({"fact":"Skin & Coat Soft Chews contain omega-3 fatty acids and biotin. The label shows the guaranteed analysis.","detail":"See the full ingredients and how many chews to give.","link":"/products/puzzlepup-skin-coat-soft-chews#pp-expert","label":"Read the full product label"})
  });

  var GENERAL_FAQ = Object.freeze([
    Object.freeze({
      q: "How do I give the chews?",
      a: "Hand over the chew count printed on the jar for your dog’s size at the same easy moment each day. Most pups think this job is suspiciously delicious.",
    }),
    Object.freeze({
      q: "When should I expect a difference?",
      a: "Every dog writes a different timeline. Keep the daily chew count steady and compare the exact clue you picked instead of trying to judge everything at once.",
    }),
    Object.freeze({
      q: "When should I ask my veterinarian first?",
      a: "Ask your veterinarian before starting if your dog is pregnant, nursing, taking medicine, has a health condition, is very young, or suddenly seems very unwell. A chew belongs beside veterinary care—not in its place.",
    }),
    Object.freeze({
      q: "What if it is not right for my dog?",
      a: "Let your pup vote. If the chew is not a fit, contact PuzzlePup within 30 days for the money-back guarantee.",
    }),
    Object.freeze({
      q: "Can I change or cancel a subscription?",
      a: "Yep. Skip, change, pause, or cancel anytime. We use your dog’s size to show how many jars you need and how often they would arrive.",
    }),
  ]);

  function normalizeEntryGoal(value) {
    var key = String(value || "")
      .toLowerCase()
      .trim();
    return key === "allergy" || key === "joint" || key === "skin" ? key : "";
  }

  function refillForWeight(value) {
    var weight = Number(value);
    if (!Number.isFinite(weight) || weight < 1 || weight > 250) return null;
    var base = weight < 25 ? REFILL_PLANS.small : weight <= 50 ? REFILL_PLANS.medium : REFILL_PLANS.large;
    var quantity = Math.max(1, Math.min(2, Number(selectedJarQuantity || 1)));
    var minChews = weight < 25 ? 1 : weight <= 50 ? 1 : 2;
    var maxChews = base.chewsPerDay;
    var lowDays = Math.floor(60 * quantity / maxChews);
    var highDays = Math.floor(60 * quantity / minChews);
    var days = lowDays === highDays ? String(lowDays) : lowDays + "–" + highDays;
    return Object.assign({}, base, {quantity:quantity,minChews:minChews,servingLabel:minChews===maxChews?String(maxChews):minChews+"–"+maxChews,deliveryDays:base.jarDays*quantity,summary:quantity+" jar"+(quantity===1?"":"s")+" · approximately "+days+" days, depending on the labeled serving"});
  }

  function detailOptionById(goal, id) {
    var options = DETAIL_OPTIONS[goal] || [];
    for (var index = 0; index < options.length; index += 1) {
      if (options[index].id === id) return options[index];
    }
    return null;
  }

  function recommendationForAnswers(answers) {
    var scores = { A: 0, J: 0, S: 0 };
    var signals = { A: 0, J: 0, S: 0 };

    if (entryGoal === "allergy") scores.A += 3;
    if (entryGoal === "joint") scores.J += 3;
    if (entryGoal === "skin") scores.S += 3;

    (Array.isArray(answers.skin) ? answers.skin : []).forEach(function (id) {
      if (id === "none") return;
      scores.S += 3;
      signals.S += 1;
    });
    (Array.isArray(answers.allergy) ? answers.allergy : []).forEach(function (id) {
      if (id === "none") return;
      scores.A += 4;
      signals.A += 1;
    });
    (Array.isArray(answers.gut) ? answers.gut : []).forEach(function (id) {
      if (id === "none") return;
      scores.A += 1;
      signals.A += 1;
    });
    (Array.isArray(answers.mobility) ? answers.mobility : []).forEach(function (id) {
      if (id === "none") return;
      scores.J += 4;
      signals.J += 1;
    });

    var ranked = ["A", "J", "S"].sort(function (left, right) {
      return scores[right] - scores[left];
    });
    var primaryKey = ranked[0] || (entryGoal === "joint" ? "J" : entryGoal === "skin" ? "S" : "A");
    if (scores.A === 0 && scores.J === 0 && scores.S === 0) {
      primaryKey = entryGoal === "joint" ? "J" : entryGoal === "skin" ? "S" : "A";
    }
    var secondaryKey = null;
    for (var rankIndex = 1; rankIndex < ranked.length; rankIndex += 1) {
      var candidate = ranked[rankIndex];
      if (scores[candidate] > 0 && signals[candidate] > 0 && candidate !== primaryKey) {
        secondaryKey = candidate;
        break;
      }
    }

    return {
      noMatch: false,
      primaryKey: primaryKey,
      secondaryKey: secondaryKey,
      vetFirst: false,
      scores: scores,
      signals: signals,
    };
  }

  function money(cents) {
    return "$" + (Number(cents || 0) / 100).toFixed(2);
  }

  var publicApi = {
    version: VERSION,
    initialized: false,
    qaEvents: [],
    qaCartPayloads: [],
    lastQaCartPayload: null,
    normalizeEntryGoal: normalizeEntryGoal,
    refillForWeight: refillForWeight,
    recommendationForAnswers: recommendationForAnswers,
    products: PRODUCTS,
  };
  window.PuzzlePupQuizV17 = publicApi;

  var mount = document.getElementById("pp-quiz-mount");
  if (!mount) return;
  publicApi.initialized = true;
  mount.setAttribute("data-pp-quiz-version", VERSION);

  var CSS = `
    #pp-quiz-v17 {
      --blue: #003da6;
      --blue-dark: #002e80;
      --blue-soft: #eaf3fc;
      --navy: #141f2d;
      --muted: #526171;
      --line: #d7e2ef;
      --soft: #f5f8fc;
      --gold: #f4b400;
      --warning: #8a3b12;
      --warning-bg: #fff5ea;
      --danger: #a52b21;
      --danger-bg: #fff1ef;
      --success: #087a67;
      --head: "Baloo 2", "Segoe UI", system-ui, sans-serif;
      --body: "Nunito", "Segoe UI", system-ui, sans-serif;
      min-height: 100vh;
      min-height: 100svh;
      padding: 14px 14px 96px;
      color: var(--navy);
      background: linear-gradient(180deg, #eaf3fc 0, #fff 52%);
      font-family: var(--body);
      font-size: 18px;
      line-height: 1.5;
      -webkit-font-smoothing: antialiased;
    }
    #pp-quiz-v17 *, #pp-quiz-v17 *::before, #pp-quiz-v17 *::after { box-sizing: border-box; }
    #pp-quiz-v17 [hidden] { display: none !important; }
    #pp-quiz-v17 img { display: block; max-width: 100%; }
    #pp-quiz-v17 button, #pp-quiz-v17 input { font: inherit; }
    #pp-quiz-v17 button, #pp-quiz-v17 a, #pp-quiz-v17 input, #pp-quiz-v17 summary { touch-action: manipulation; }
    #pp-quiz-v17 .pp-shell { width: min(100%, 650px); margin: 0 auto; }
    #pp-quiz-v17.is-result-mode .pp-shell { width: min(100%, 660px); }
    #pp-quiz-v17 .pp-header { display: flex; align-items: center; justify-content: space-between; gap: 16px; min-height: 58px; margin-bottom: 10px; }
    #pp-quiz-v17 .pp-logo { width: auto; height: 50px; }
    #pp-quiz-v17 .pp-cart { display: inline-flex; align-items: center; justify-content: center; min-width: 48px; min-height: 48px; padding: 8px 10px; color: var(--blue); font-family: var(--head); font-weight: 800; text-decoration: none; border-radius: 12px; }
    #pp-quiz-v17 .pp-card { overflow: visible; padding: 22px 18px; background: #fff; border: 1px solid var(--line); border-radius: 22px; box-shadow: 0 16px 42px rgba(20,31,45,.1); }
    #pp-quiz-v17 .pp-screen { min-height: calc(100svh - 170px); }
    #pp-quiz-v17 .pp-question { display: flex; flex-direction: column; }
    #pp-quiz-v17 h1, #pp-quiz-v17 h2, #pp-quiz-v17 h3, #pp-quiz-v17 h4 { color: var(--navy); font-family: var(--head); line-height: 1.15; }
    #pp-quiz-v17 h1 { margin: 0 0 10px; font-size: clamp(30px, 7vw, 43px); }
    #pp-quiz-v17 h2 { margin: 0 0 10px; font-size: clamp(27px, 6vw, 35px); }
    #pp-quiz-v17 h3 { margin: 0 0 8px; font-size: 23px; }
    #pp-quiz-v17 h1:focus, #pp-quiz-v17 h2:focus { outline: none; }
    #pp-quiz-v17 .pp-center { text-align: center; }
    #pp-quiz-v17 .pp-sub { margin: 0 0 18px; color: var(--muted); font-size: 19px; line-height: 1.48; }
    #pp-quiz-v17 .pp-eyebrow { display: inline-flex; align-items: center; min-height: 32px; margin-bottom: 10px; padding: 5px 12px; color: var(--blue); background: var(--blue-soft); border-radius: 999px; font-weight: 900; font-size: 14px; letter-spacing: .04em; text-transform: uppercase; }
    #pp-quiz-v17 .pp-hero { display:block; width:min(100%,700px); height:auto; aspect-ratio:1 / 1; margin:0 auto 18px; padding:0; object-fit:contain; object-position:center; background:#fff; border-radius:17px; }
    #pp-quiz-v17 .pp-question-hero { width:100%; aspect-ratio:1080 / 651; object-fit:cover; }
    #pp-quiz-v17 .pp-outcomes { display: grid; grid-template-columns: repeat(3, 1fr); gap: 8px; margin: 18px 0; }
    #pp-quiz-v17 .pp-outcome { padding: 12px 8px; color: var(--navy); background: var(--soft); border: 1px solid var(--line); border-radius: 13px; font-size: 14px; font-weight: 800; text-align: center; line-height: 1.3; }
    #pp-quiz-v17 .pp-outcome b { display: block; color: var(--blue); font-size: 18px; }
    #pp-quiz-v17 .pp-trust { display: flex; flex-wrap: wrap; justify-content: center; gap: 8px; margin: 15px 0 0; }
    #pp-quiz-v17 .pp-trust span { padding: 7px 10px; color: var(--navy); background: #fff; border: 1px solid var(--line); border-radius: 999px; font-size: 14px; font-weight: 800; }
    #pp-quiz-v17 .pp-target-note, #pp-quiz-v17 .pp-why { margin: 0 0 16px; padding: 12px 14px; color: var(--navy); background: var(--blue-soft); border: 1px solid #c8dcf4; border-radius: 13px; font-size: 16px; }
    #pp-quiz-v17 .pp-target-note b, #pp-quiz-v17 .pp-why b { color: var(--blue); }
    #pp-quiz-v17 .pp-campaign { margin: 14px 0; padding: 13px 15px; color: var(--navy); background: #fff8df; border: 1px solid #efd37b; border-radius: 14px; text-align: center; }
    #pp-quiz-v17 .pp-campaign b { font-family: var(--head); }
    #pp-quiz-v17 .pp-topline { display: flex; align-items: center; justify-content: space-between; gap: 12px; min-height: 48px; margin-bottom: 5px; }
    #pp-quiz-v17 .pp-topline-first { justify-content:flex-end; }
    #pp-quiz-v17 .pp-back, #pp-quiz-v17 .pp-link-button { display: inline-flex; align-items: center; justify-content: center; min-height: 48px; padding: 8px 10px; color: var(--blue); background: transparent; border: 0; border-radius: 10px; cursor: pointer; font-weight: 800; text-decoration: underline; }
    #pp-quiz-v17 .pp-step-count { color: var(--blue); font-size: 14px; font-weight: 900; letter-spacing: .04em; text-transform: uppercase; }
    #pp-quiz-v17 .pp-progress { height: 9px; margin-bottom: 22px; overflow: hidden; background: #e1eaf5; border-radius: 999px; }
    #pp-quiz-v17 .pp-progress > span { display: block; height: 100%; background: linear-gradient(90deg, #5aa9e6, var(--blue)); border-radius: inherit; transition: width .22s ease; }
    #pp-quiz-v17 .pp-choices { display: grid; gap: 11px; }
    #pp-quiz-v17 .pp-goals { grid-template-columns: 1fr 1fr; }
    #pp-quiz-v17 .pp-choice { position: relative; display: flex; align-items: center; width: 100%; min-height: 62px; gap: 12px; padding: 13px 14px; color: var(--navy); background: #fff; border: 2px solid var(--line); border-radius: 15px; cursor: pointer; text-align: left; font-weight: 800; line-height: 1.3; transition: border-color .15s, background .15s, transform .15s; }
    #pp-quiz-v17 .pp-goals .pp-choice { min-height: 126px; flex-direction: column; align-items: flex-start; justify-content: center; }
    #pp-quiz-v17 .pp-choice:hover { border-color: var(--blue); background: var(--blue-soft); transform: translateY(-1px); }
    #pp-quiz-v17 .pp-choice.is-selected { border-color: var(--blue); background: var(--blue-soft); box-shadow: 0 0 0 2px rgba(0,61,166,.08); }
    #pp-quiz-v17 .pp-choice small { display: block; margin-top: 4px; color: var(--muted); font-size: 15px; font-weight: 700; line-height: 1.35; }
    #pp-quiz-v17 .pp-choice-icon { display: grid; place-items: center; flex: 0 0 38px; width: 38px; height: 38px; font-size: 26px; }
    #pp-quiz-v17 .pp-goals .pp-choice-icon { width: 42px; height: 42px; font-size: 31px; }
    #pp-quiz-v17 .pp-choice-check { display: grid; place-items: center; flex: 0 0 27px; width: 27px; height: 27px; margin-left: auto; color: #fff; border: 2px solid #afbed0; border-radius: 50%; }
    #pp-quiz-v17 .pp-choice.is-selected .pp-choice-check { background: var(--blue); border-color: var(--blue); }
    #pp-quiz-v17 .pp-inline-choice { margin-top:10px; }
    #pp-quiz-v17 .pp-urgent-option { border-color: #e8c0b7; }
    #pp-quiz-v17 .pp-field-wrap { margin-top: 5px; }
    #pp-quiz-v17 .pp-label { display: block; margin: 0 0 7px; color: var(--navy); font-weight: 900; }
    #pp-quiz-v17 .pp-field { width: 100%; min-height: 56px; padding: 13px 15px; color: var(--navy); background: #fff; border: 2px solid var(--line); border-radius: 14px; font-size: 19px; }
    #pp-quiz-v17 .pp-field:focus { outline: none; border-color: var(--blue); box-shadow: 0 0 0 4px rgba(0,61,166,.13); }
    #pp-quiz-v17 .pp-group-label { margin-top:18px; }
    #pp-quiz-v17 .pp-age-fields { display:grid; grid-template-columns:1fr 1fr; gap:12px; }
    #pp-quiz-v17 .pp-education-note { display:grid; grid-template-columns:46px minmax(0,1fr); align-items:start; gap:12px; margin-top:16px; padding:14px; color:var(--navy); background:var(--blue-soft); border:1px solid #c8dcf4; border-radius:14px; }
    #pp-quiz-v17 .pp-education-icon { display:grid; place-items:center; width:46px; height:46px; background:#fff; border-radius:50%; font-size:25px; }
    #pp-quiz-v17 .pp-education-note b { display:block; color:var(--blue); font-family:var(--head); font-size:18px; }
    #pp-quiz-v17 .pp-education-note p { margin:3px 0 0; color:var(--muted); font-size:15px; line-height:1.42; }
    #pp-quiz-v17 .pp-btn { display: inline-flex; align-items: center; justify-content: center; width: 100%; min-height: 56px; padding: 14px 20px; color: #fff; background: var(--blue); border: 0; border-radius: 999px; box-shadow: 0 9px 22px rgba(0,61,166,.27); cursor: pointer; font-family: var(--head); font-size: 22px; font-weight: 900; line-height: 1.2; transition: background .15s, transform .15s, opacity .15s; }
    #pp-quiz-v17 .pp-btn:hover { background: var(--blue-dark); transform: translateY(-1px); }
    #pp-quiz-v17 .pp-btn:disabled { cursor: not-allowed; opacity: .46; transform: none; box-shadow: none; }
    #pp-quiz-v17 .pp-btn-secondary { color: var(--blue); background: #fff; border: 2px solid var(--blue); box-shadow: none; }
    #pp-quiz-v17 .pp-btn-secondary:hover { color: #fff; }
    #pp-quiz-v17 .pp-next { margin-top: 20px; }
    #pp-quiz-v17 .pp-inline-error { display: none; margin: 9px 0 0; color: var(--danger); font-weight: 800; font-size: 15px; }
    #pp-quiz-v17 .pp-inline-error.is-visible { display: block; }
    #pp-quiz-v17 .pp-guidance { margin: 14px 0; padding: 13px 15px; color: var(--warning); background: var(--warning-bg); border: 1px solid #efc58d; border-radius: 14px; font-size: 16px; }
    #pp-quiz-v17 .pp-guidance-danger { color: var(--danger); background: var(--danger-bg); border-color: #e8aaa4; }
    #pp-quiz-v17 .pp-guidance b { display: block; margin-bottom: 2px; font-family: var(--head); }
    #pp-quiz-v17 .pp-preview { display: grid; grid-template-columns: 104px 1fr; align-items: center; gap: 14px; margin: 15px 0; padding: 13px; background: var(--soft); border: 1px solid var(--line); border-radius: 15px; text-align: left; }
    #pp-quiz-v17 .pp-preview img { width: 104px; height: 104px; object-fit: cover; border-radius: 12px; }
    #pp-quiz-v17 .pp-preview p { margin: 3px 0 0; color: var(--muted); font-size: 15px; }
    #pp-quiz-v17 .pp-serving-mini { margin-top: 7px; color: var(--blue); font-weight: 900; }
    #pp-quiz-v17 .pp-consent { display: flex; align-items: flex-start; gap: 10px; margin: 12px 0 0; color: var(--muted); cursor: pointer; font-size: 14px; line-height: 1.4; }
    #pp-quiz-v17 .pp-consent input, #pp-quiz-v17 .pp-addon input { flex: 0 0 24px; width: 24px; height: 24px; margin: 1px 0 0; accent-color: var(--blue); }
    #pp-quiz-v17 .pp-skip { display: flex; margin: 11px auto 0; }
    #pp-quiz-v17 .pp-result-screen { min-height: auto; }
    #pp-quiz-v17 .pp-result-primary-cta { max-width: 440px; margin: 16px auto 0; text-decoration: none; }
    #pp-quiz-v17 .pp-trustline { margin-top: 9px; color: var(--muted); font-size: 14px; font-weight: 900; }
    #pp-quiz-v17 .pp-result-hero { display:block; width:min(100%,820px); height:auto; max-height:none; aspect-ratio:1 / 1; margin:0 auto 20px; padding:0; object-fit:contain; object-position:center; background:#fff; border-radius:16px; }
    #pp-quiz-v17 .pp-offer-grid { display: grid; grid-template-columns: minmax(0, 1fr); align-items: start; gap: 20px; margin: 20px 0 10px; }
    #pp-quiz-v17 .pp-gallery { min-width: 0; overflow: hidden; background: #fff; border: 1px solid var(--line); border-radius: 18px; box-shadow: 0 12px 28px rgba(20,31,45,.08); }
    #pp-quiz-v17 .pp-gallery-track { display: flex; width: 100%; overflow-x: auto; overflow-y: hidden; scroll-snap-type: x mandatory; scrollbar-width: none; overscroll-behavior-x: contain; }
    #pp-quiz-v17 .pp-gallery-track::-webkit-scrollbar { display: none; }
    #pp-quiz-v17 .pp-gallery-slide { flex: 0 0 100%; min-width: 0; margin: 0; scroll-snap-align: start; scroll-snap-stop: always; }
    #pp-quiz-v17 .pp-gallery-image-button { display:block; width:100%; padding:0; background:#fff; border:0; cursor:pointer; }
    #pp-quiz-v17 .pp-gallery-slide img { width: 100%; height: auto; aspect-ratio: 1 / 1; object-fit: contain; object-position: center; background: #fff; }
    #pp-quiz-v17 .pp-gallery-slide figcaption { min-height: 60px; padding: 11px 14px; color: var(--navy); background: var(--soft); border-top: 1px solid var(--line); font-size: 15px; font-weight: 900; line-height: 1.3; text-align: center; }
    #pp-quiz-v17 .pp-gallery-controls { display: grid; grid-template-columns: 46px minmax(0, 1fr) 46px; align-items: center; gap: 8px; padding: 10px 12px 12px; }
    #pp-quiz-v17 .pp-gallery-arrow { display: grid; place-items: center; width: 44px; height: 44px; padding: 0; color: var(--blue); background: #fff; border: 1px solid #b8d0ee; border-radius: 50%; cursor: pointer; font-family: var(--head); font-size: 26px; font-weight: 900; }
    #pp-quiz-v17 .pp-gallery-dots { display: flex; flex-wrap: wrap; justify-content: center; gap: 7px; }
    #pp-quiz-v17 .pp-gallery-dot { width: 12px; height: 12px; padding: 0; background: #c8d6e7; border: 0; border-radius: 50%; cursor: pointer; }
    #pp-quiz-v17 .pp-gallery-dot.is-active { background: var(--blue); box-shadow: 0 0 0 3px rgba(0,61,166,.13); }
    #pp-quiz-v17 .pp-gallery-counter { color:var(--navy); font-family:var(--head); font-size:15px; font-weight:900; text-align:center; }
    #pp-quiz-v17 .pp-offer-grid .pp-purchase { position: static; margin: 0; }
    #pp-quiz-v17 .pp-visual-story { display: grid; grid-template-columns: 1.15fr .85fr; align-items: start; gap: 18px; margin-top: 26px; }
    #pp-quiz-v17 .pp-visual-card { overflow: hidden; margin: 0; background: #fff; border: 1px solid var(--line); border-radius: 18px; box-shadow: 0 10px 24px rgba(20,31,45,.07); }
    #pp-quiz-v17 .pp-visual-card img { width: 100%; height: auto; object-fit: contain; object-position: center; background: #fff; }
    #pp-quiz-v17 .pp-visual-card.is-landscape img { aspect-ratio: 3 / 2; }
    #pp-quiz-v17 .pp-visual-card.is-square img { aspect-ratio: 1 / 1; }
    #pp-quiz-v17 .pp-visual-card figcaption { padding: 14px 16px 16px; color: var(--muted); font-size: 15px; line-height: 1.4; }
    #pp-quiz-v17 .pp-visual-card figcaption b { display: block; margin-bottom: 3px; color: var(--navy); font-family: var(--head); font-size: 21px; }
    #pp-quiz-v17 .pp-proof-grid { display: grid; grid-template-columns: 1fr 1fr; align-items: stretch; gap: 18px; margin-top: 22px; }
    #pp-quiz-v17 .pp-proof-grid .pp-proof { height: 100%; margin-top: 0; }
    #pp-quiz-v17 .pp-quality-panel { padding: 17px; background: var(--blue-soft); border: 1px solid #c2d9f4; border-radius: 16px; }
    #pp-quiz-v17 .pp-quality-panel h3 { margin: 0 0 5px; }
    #pp-quiz-v17 .pp-quality-panel p { margin: 0; color: var(--muted); font-size: 15px; }
    #pp-quiz-v17 .pp-visually-hidden { position: absolute !important; width: 1px !important; height: 1px !important; padding: 0 !important; margin: -1px !important; overflow: hidden !important; clip: rect(0,0,0,0) !important; white-space: nowrap !important; border: 0 !important; }
    #pp-quiz-v17 .pp-badge { display: inline-flex; min-height: 32px; align-items: center; margin-bottom: 10px; padding: 5px 11px; color: #fff; background: var(--blue); border-radius: 999px; font-size: 13px; font-weight: 900; letter-spacing: .05em; text-transform: uppercase; }
    #pp-quiz-v17 .pp-dose-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 8px; margin: 15px 0; }
    #pp-quiz-v17 .pp-dose-cell { padding: 12px 8px; background: var(--blue-soft); border: 1px solid #c7dcf5; border-radius: 13px; text-align: center; }
    #pp-quiz-v17 .pp-dose-cell b { display: block; color: var(--blue); font-family: var(--head); font-size: 20px; line-height: 1.2; }
    #pp-quiz-v17 .pp-dose-cell span { display: block; margin-top: 3px; color: var(--muted); font-size: 13px; line-height: 1.25; }
    #pp-quiz-v17 .pp-profile-grid .pp-dose-cell { display:flex; min-width:0; flex-direction:column; justify-content:center; }
    #pp-quiz-v17 .pp-profile-grid .pp-dose-cell span { order:0; margin:0 0 4px; color:var(--muted); font-size:12px; font-weight:900; letter-spacing:.04em; text-transform:uppercase; }
    #pp-quiz-v17 .pp-profile-grid .pp-dose-cell b { order:1; overflow-wrap:anywhere; font-size:17px; }
    #pp-quiz-v17 .pp-health-report { margin:18px 0 24px; text-align:left; }
    #pp-quiz-v17 .pp-health-report h2 { margin-bottom:12px; text-align:center; }
    #pp-quiz-v17 .pp-health-categories { display:grid; grid-template-columns:repeat(4,minmax(0,1fr)); gap:8px; }
    #pp-quiz-v17 .pp-health-category { position:relative; display:flex; min-width:0; min-height:118px; flex-direction:column; align-items:center; justify-content:flex-start; padding:12px 5px 10px; background:var(--soft); border:1px solid var(--line); border-radius:14px; text-align:center; }
    #pp-quiz-v17 .pp-health-category-icon { display:grid; place-items:center; width:40px; height:40px; margin-bottom:7px; background:#fff; border:1px solid #c7dcf5; border-radius:50%; font-size:22px; }
    #pp-quiz-v17 .pp-health-category-count { position:absolute; top:7px; right:7px; display:grid; place-items:center; min-width:23px; height:23px; padding:0 5px; color:#fff; background:var(--blue); border-radius:999px; font-size:12px; font-weight:900; }
    #pp-quiz-v17 .pp-health-category b { color:var(--navy); font-family:var(--head); font-size:13px; line-height:1.18; }
    #pp-quiz-v17 .pp-health-category small { margin-top:4px; color:var(--muted); font-size:11px; font-weight:800; line-height:1.2; }
    #pp-quiz-v17 .pp-recommendations { margin-top:22px; }
    #pp-quiz-v17 .pp-recommendations > h2 { margin-bottom:14px; text-align:center; }
    #pp-quiz-v17 .pp-recommendation-card { overflow:hidden; margin-bottom:22px; background:#fff; border:1px solid var(--line); border-radius:19px; box-shadow:0 12px 30px rgba(20,31,45,.09); }
    #pp-quiz-v17 .pp-recommendation-card.is-bundle { border:2px solid var(--blue); }
    #pp-quiz-v17 .pp-recommendation-card .pp-gallery { border:0; border-radius:0; box-shadow:none; }
    #pp-quiz-v17 .pp-recommendation-copy { padding:18px; }
    #pp-quiz-v17 .pp-recommendation-copy h3 { margin:0 0 7px; font-size:27px; }
    #pp-quiz-v17 .pp-recommendation-copy p { margin:0; color:var(--muted); font-size:16px; line-height:1.45; }
    #pp-quiz-v17 .pp-recommendation-benefits { display:grid; gap:8px; margin:15px 0; padding:0; list-style:none; }
    #pp-quiz-v17 .pp-recommendation-benefits li { display:flex; align-items:flex-start; gap:9px; color:var(--navy); font-weight:800; }
    #pp-quiz-v17 .pp-recommendation-benefits li span { display:grid; place-items:center; flex:0 0 23px; width:23px; height:23px; color:#fff; background:var(--blue); border-radius:50%; font-size:13px; }
    #pp-quiz-v17 .pp-recommendation-price { display:flex; align-items:baseline; gap:6px; margin:12px 0; }
    #pp-quiz-v17 .pp-recommendation-price b { color:var(--blue); font-family:var(--head); font-size:29px; }
    #pp-quiz-v17 .pp-choose-package { margin-top:4px; }
    #pp-quiz-v17 .pp-learn-more { display:block; min-height:44px; margin-top:9px; padding:11px; color:var(--blue); font-weight:900; text-align:center; }
    #pp-quiz-v17 .pp-primary-product { display: grid; grid-template-columns: 122px 1fr; align-items: center; gap: 14px; margin: 13px 0 15px; padding: 13px; background: var(--soft); border: 1px solid var(--line); border-radius: 15px; }
    #pp-quiz-v17 .pp-primary-product img { width: 122px; height: 122px; object-fit: cover; border-radius: 12px; }
    #pp-quiz-v17 .pp-primary-product a, #pp-quiz-v17 .pp-secondary-card a, #pp-quiz-v17 .pp-proof a { color: var(--blue); font-weight: 900; }
    #pp-quiz-v17 .pp-primary-product p { margin: 5px 0 0; color: var(--muted); font-size: 15px; }
    #pp-quiz-v17 .pp-rationale { margin: 17px 0; padding: 17px; background: linear-gradient(145deg, #eef6ff, #fff); border: 2px solid #bdd5f2; border-radius: 17px; }
    #pp-quiz-v17 .pp-rationale h3 { color: var(--blue); }
    #pp-quiz-v17 .pp-rationale p { margin: 8px 0 0; color: var(--navy); }
    #pp-quiz-v17 .pp-signal-list { display: flex; flex-wrap: wrap; gap: 7px; margin-top: 11px; }
    #pp-quiz-v17 .pp-signal-chip { padding: 6px 9px; color: var(--blue-dark); background: #fff; border: 1px solid #b9d3f2; border-radius: 999px; font-size: 13px; font-weight: 900; }
    #pp-quiz-v17 .pp-action-callout { margin-top: 13px; padding: 12px 13px; color: #fff; background: var(--blue); border-radius: 12px; font-weight: 900; }
    #pp-quiz-v17 .pp-formula-flow { display: grid; grid-template-columns: 1fr auto 1fr auto 1fr; align-items: stretch; gap: 7px; margin-top: 12px; }
    #pp-quiz-v17 .pp-flow-card { display: flex; flex-direction: column; justify-content: center; min-height: 105px; padding: 11px; background: #fff; border: 1px solid var(--line); border-radius: 13px; text-align: center; }
    #pp-quiz-v17 .pp-flow-card b { color: var(--blue); font-family: var(--head); }
    #pp-quiz-v17 .pp-flow-card span { margin-top: 3px; color: var(--muted); font-size: 13px; line-height: 1.3; }
    #pp-quiz-v17 .pp-flow-arrow { align-self: center; color: var(--blue); font-size: 25px; font-weight: 900; }
    #pp-quiz-v17 .pp-formula-compare { display: grid; grid-template-columns: repeat(3, 1fr); gap: 8px; }
    #pp-quiz-v17 .pp-formula-card { position: relative; min-height: 122px; padding: 12px 9px; background: #fff; border: 1px solid var(--line); border-radius: 13px; text-align: center; }
    #pp-quiz-v17 .pp-formula-card.is-match { color: #fff; background: var(--blue); border-color: var(--blue); box-shadow: 0 9px 22px rgba(0,61,166,.2); }
    #pp-quiz-v17 .pp-formula-card b { display: block; margin: 4px 0; color: inherit; font-family: var(--head); line-height: 1.15; }
    #pp-quiz-v17 .pp-formula-card span { display: block; color: var(--muted); font-size: 12px; line-height: 1.3; }
    #pp-quiz-v17 .pp-formula-card.is-match span { color: #e5efff; }
    #pp-quiz-v17 .pp-match-flag { display: inline-flex !important; width: max-content; margin: 0 auto 5px; padding: 3px 7px; color: var(--blue) !important; background: #fff; border-radius: 999px; font-size: 10px !important; font-weight: 900; text-transform: uppercase; }
    #pp-quiz-v17 .pp-quality-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 8px; margin-top: 12px; }
    #pp-quiz-v17 .pp-quality { display: flex; align-items: center; gap: 8px; min-height: 54px; padding: 10px; background: #fff; border: 1px solid var(--line); border-radius: 12px; font-size: 14px; font-weight: 900; }
    #pp-quiz-v17 .pp-quality span { font-size: 21px; }
    #pp-quiz-v17 .pp-purchase { scroll-margin-top: 18px; margin: 17px 0 20px; padding: 16px; background: #fff; border: 2px solid var(--blue); border-radius: 18px; box-shadow: 0 12px 28px rgba(0,61,166,.1); }
    #pp-quiz-v17 .pp-purchase fieldset { min-width: 0; margin: 0; padding: 0; border: 0; }
    #pp-quiz-v17 .pp-purchase legend { margin-bottom: 11px; color: var(--navy); font-family: var(--head); font-size: 23px; font-weight: 900; }
    #pp-quiz-v17 .pp-plan { position: relative; display: block; margin: 0 0 10px; cursor: pointer; }
    #pp-quiz-v17 .pp-plan input { position: absolute; width: 1px; height: 1px; opacity: 0; pointer-events: none; }
    #pp-quiz-v17 .pp-plan-box { display: flex; min-height: 130px; flex-direction: column; justify-content: center; padding: 13px 14px; border: 2px solid var(--line); border-radius: 14px; transition: border-color .15s, background .15s; }
    #pp-quiz-v17 .pp-plan-help { margin: -2px 0 12px; color: var(--muted); font-size: 13px; line-height: 1.35; text-align: center; }
    #pp-quiz-v17 .pp-plan:hover .pp-plan-box { border-color: #91b6e6; }
    #pp-quiz-v17 .pp-plan input:focus-visible + .pp-plan-box { outline: 3px solid rgba(0,61,166,.24); outline-offset: 2px; }
    #pp-quiz-v17 .pp-plan input:checked + .pp-plan-box { background: var(--blue-soft); border-color: var(--blue); }
    #pp-quiz-v17 .pp-plan-top { display: flex; align-items: flex-start; justify-content: space-between; gap: 10px; }
    #pp-quiz-v17 .pp-plan-name { color: var(--navy); font-family: var(--head); font-size: 20px; font-weight: 900; }
    #pp-quiz-v17 .pp-plan-price { color: var(--blue); font-family: var(--head); font-size: 22px; font-weight: 900; white-space: nowrap; }
    #pp-quiz-v17 .pp-compare { margin-left: 5px; color: #718092; font-family: var(--body); font-size: 14px; font-weight: 700; text-decoration: line-through; }
    #pp-quiz-v17 .pp-plan-copy { display: block; margin-top: 4px; color: var(--muted); font-size: 14px; line-height: 1.35; }
    #pp-quiz-v17 .pp-plan-copy .pp-save-label { margin-left: 0; }
    #pp-quiz-v17 .pp-save-label { display: inline-flex; margin-left: 5px; padding: 2px 7px; color: #fff; background: var(--success); border-radius: 999px; font-family: var(--body); font-size: 11px; font-weight: 900; vertical-align: 2px; }
    #pp-quiz-v17 .pp-selected-cost { display: none; margin: 12px 0; padding: 11px 13px; color: var(--navy); background: var(--soft); border-radius: 12px; font-weight: 800; text-align: center; }
    #pp-quiz-v17 .pp-selected-cost.is-visible { display: block; }
    #pp-quiz-v17 .pp-selected-cost b { color: var(--blue); }
    #pp-quiz-v17 .pp-addons { display: none; margin: 14px 0 12px; padding-top: 14px; border-top: 1px solid var(--line); }
    #pp-quiz-v17 .pp-addons.is-visible { display: block; }
    #pp-quiz-v17 .pp-addons h4 { margin: 0 0 8px; font-size: 18px; }
    #pp-quiz-v17 .pp-addon { display: flex; align-items: flex-start; gap: 10px; min-height: 60px; margin-top: 8px; padding: 10px 11px; background: var(--soft); border: 1px solid var(--line); border-radius: 12px; cursor: pointer; }
    #pp-quiz-v17 .pp-addon-image { flex: 0 0 58px; width: 58px; height: 58px; object-fit: contain; background: #fff; border-radius: 10px; }
    #pp-quiz-v17 .pp-addon-copy { flex: 1; min-width: 0; overflow-wrap: anywhere; }
    #pp-quiz-v17 .pp-addon-copy b, #pp-quiz-v17 .pp-addon-copy span { overflow-wrap: anywhere; }
    #pp-quiz-v17 .pp-addon-copy b { display: block; color: var(--navy); }
    #pp-quiz-v17 .pp-addon-copy span { display: block; color: var(--muted); font-size: 13px; }
    #pp-quiz-v17 .pp-addon-price { color: var(--blue); font-weight: 900; white-space: nowrap; }
    #pp-quiz-v17 .pp-addon-price s { display: block; color: var(--muted); font-size: 12px; font-weight: 700; }
    #pp-quiz-v17 .pp-purchase-note { margin: 10px 0 0; color: var(--muted); font-size: 13px; text-align: center; }
    #pp-quiz-v17 .pp-cart-error { display: none; margin: 10px 0 0; padding: 10px; color: var(--danger); background: var(--danger-bg); border-radius: 10px; font-weight: 800; }
    #pp-quiz-v17 .pp-cart-error.is-visible { display: block; }
    #pp-quiz-v17 .pp-secondary-card { margin: 18px 0; padding: 14px 15px; background: var(--blue-soft); border: 1px solid #c8dcf4; border-radius: 14px; }
    #pp-quiz-v17 .pp-secondary-card p { margin: 4px 0 0; color: var(--muted); font-size: 15px; }
    #pp-quiz-v17 .pp-section { margin-top: 24px; }
    #pp-quiz-v17 .pp-section-title { display: flex; align-items: center; gap: 9px; margin-bottom: 11px; font-family: var(--head); font-size: 22px; font-weight: 900; }
    #pp-quiz-v17 .pp-section-title span { display: grid; place-items: center; flex: 0 0 34px; width: 34px; height: 34px; background: var(--blue-soft); border-radius: 9px; }
    #pp-quiz-v17 .pp-benefits, #pp-quiz-v17 .pp-ingredients { display: grid; gap: 9px; }
    #pp-quiz-v17 .pp-benefit, #pp-quiz-v17 .pp-ingredient { display: flex; align-items: flex-start; gap: 10px; padding: 12px 13px; background: var(--soft); border: 1px solid var(--line); border-radius: 12px; }
    #pp-quiz-v17 .pp-check { display: grid; place-items: center; flex: 0 0 23px; width: 23px; height: 23px; color: #fff; background: var(--blue); border-radius: 50%; font-size: 13px; font-weight: 900; }
    #pp-quiz-v17 .pp-ingredient b { color: var(--navy); }
    #pp-quiz-v17 .pp-ingredient span { color: var(--muted); }
    #pp-quiz-v17 .pp-proof { margin-top: 20px; padding: 17px; color: #fff; background: var(--navy); border-radius: 15px; }
    #pp-quiz-v17 .pp-proof h3 { margin: 0 0 8px; color: #fff; }
    #pp-quiz-v17 .pp-proof p { margin: 0 0 8px; }
    #pp-quiz-v17 .pp-proof blockquote { margin: 0 0 8px; font-size: 17px; font-style: italic; }
    #pp-quiz-v17 .pp-proof small { display: block; margin-bottom: 8px; color: #b7c6d8; }
    #pp-quiz-v17 .pp-proof a { color: #9ec6ff; }
    #pp-quiz-v17 .pp-faq details { margin-bottom: 9px; overflow: hidden; background: #fff; border: 1px solid var(--line); border-radius: 12px; }
    #pp-quiz-v17 .pp-faq summary { display: flex; align-items: center; justify-content: space-between; gap: 10px; min-height: 54px; padding: 12px 14px; cursor: pointer; color: var(--navy); font-family: var(--head); font-weight: 900; list-style: none; }
    #pp-quiz-v17 .pp-faq summary::-webkit-details-marker { display: none; }
    #pp-quiz-v17 .pp-faq summary::after { content: "+"; color: var(--blue); font-size: 25px; }
    #pp-quiz-v17 .pp-faq details[open] summary::after { content: "–"; }
    #pp-quiz-v17 .pp-faq-answer { padding: 0 14px 14px; color: var(--muted); }
    #pp-quiz-v17 .pp-retake { margin-top: 17px; }
    #pp-quiz-v17 .pp-sticky-result-cta { display: none; }
    #pp-quiz-v17 .pp-no-match { padding: 17px; background: var(--soft); border: 1px solid var(--line); border-radius: 15px; }
    #pp-quiz-v17 .pp-no-match ul { margin: 10px 0 0; padding-left: 21px; }
    #pp-quiz-v17 .pp-no-match li + li { margin-top: 6px; }
    body.pp-quiz-v17-page .jdgm-floating-tab,
    body.pp-quiz-v17-page .jdgm-medals-wrapper,
    body.pp-quiz-v17-page .floating-btn,
    body.pp-quiz-v17-page .klaviyo-form,
    body.pp-quiz-v17-page [data-testid*="klaviyo"],
    body.pp-quiz-v17-page [class*="kl-private-reset-css"],
    body.pp-quiz-v17-page iframe[src*="klaviyo"],
    body.pp-quiz-v17-page #google-merchantwidget-iframe-wrapper { display: none !important; }
    @media (max-width: 700px) {
      #pp-quiz-v17 .pp-offer-grid, #pp-quiz-v17 .pp-visual-story, #pp-quiz-v17 .pp-proof-grid { grid-template-columns: minmax(0, 1fr); }
      #pp-quiz-v17 .pp-offer-grid .pp-purchase { position: static; }
      #pp-quiz-v17 .pp-multi-next { position: sticky; bottom: max(8px, env(safe-area-inset-bottom)); z-index: 5; margin-top: auto; padding-top: 16px; background: linear-gradient(180deg, rgba(255,255,255,0), #fff 24%); }
      #pp-quiz-v17 .pp-result-screen { padding-bottom: 72px; }
      #pp-quiz-v17 .pp-sticky-result-cta { position: fixed; right: 12px; bottom: max(10px, env(safe-area-inset-bottom)); left: 12px; z-index: 50; display: flex; align-items: center; justify-content: center; min-height: 54px; padding: 12px 18px; color: #fff; background: var(--blue); border: 2px solid #fff; border-radius: 999px; box-shadow: 0 12px 30px rgba(0,33,86,.34); font-family: var(--head); font-size: 18px; font-weight: 900; line-height: 1.15; text-align: center; text-decoration: none; transition: opacity .15s, transform .15s; }
      #pp-quiz-v17 .pp-sticky-result-cta.is-hidden { opacity: 0; pointer-events: none; transform: translateY(16px); }
    }
    @media (max-width: 480px) {
      #pp-quiz-v17 { padding: 8px 10px 92px; font-size: 17px; }
      #pp-quiz-v17 .pp-card { padding: 19px 14px; border-radius: 18px; }
      #pp-quiz-v17 .pp-header { margin-bottom: 5px; }
      #pp-quiz-v17 .pp-logo { height: 45px; }
      #pp-quiz-v17 .pp-goals { grid-template-columns: 1fr 1fr; gap: 8px; }
      #pp-quiz-v17 .pp-goals .pp-choice { min-height: 116px; padding: 11px; font-size: 15px; }
      #pp-quiz-v17 .pp-outcomes, #pp-quiz-v17 .pp-dose-grid { gap: 6px; }
      #pp-quiz-v17 .pp-outcome, #pp-quiz-v17 .pp-dose-cell { padding: 10px 5px; }
      #pp-quiz-v17 .pp-dose-cell b { font-size: 18px; }
      #pp-quiz-v17 .pp-primary-product { grid-template-columns: 94px 1fr; }
      #pp-quiz-v17 .pp-primary-product img { width: 94px; height: 94px; }
      #pp-quiz-v17 .pp-preview { grid-template-columns: 86px 1fr; }
      #pp-quiz-v17 .pp-preview img { width: 86px; height: 86px; }
      #pp-quiz-v17 .pp-plan-top { align-items: center; }
      #pp-quiz-v17 .pp-plan-name { font-size: 18px; }
      #pp-quiz-v17 .pp-plan-price { font-size: 19px; }
      #pp-quiz-v17 .pp-addon { display: grid; grid-template-columns: 24px 58px minmax(0, 1fr); align-items: start; gap: 8px 10px; }
      #pp-quiz-v17 .pp-addon > input { grid-column: 1; grid-row: 1; }
      #pp-quiz-v17 .pp-addon-image { grid-column: 2; grid-row: 1; }
      #pp-quiz-v17 .pp-addon-copy { grid-column: 3; grid-row: 1; min-width: 0; }
      #pp-quiz-v17 .pp-addon-price { grid-column: 2 / 4; grid-row: 2; justify-self: end; white-space: normal; }
      #pp-quiz-v17 .pp-quantity-grid { grid-template-columns: 1fr; }
      #pp-quiz-v17 .pp-quantity-choice { min-height: 86px; }
      #pp-quiz-v17 .pp-formula-flow { grid-template-columns: 1fr; }
      #pp-quiz-v17 .pp-flow-arrow { transform: rotate(90deg); }
      #pp-quiz-v17 .pp-formula-card { min-height: 112px; padding: 10px 6px; }
      #pp-quiz-v17 .pp-quality-grid { grid-template-columns: 1fr; }
    }
    #pp-quiz-v17 select.pp-field { appearance: auto; }
    #pp-quiz-v17 .pp-status-grid { display:grid; grid-template-columns:repeat(4,1fr); gap:8px; margin:14px 0 22px; }
    #pp-quiz-v17 .pp-status-grid > div { display:flex; flex-direction:column; min-height:78px; padding:12px; border:1px solid var(--line); border-radius:14px; background:var(--soft); text-align:left; }
    #pp-quiz-v17 .pp-status-grid b { color:var(--blue); }
    #pp-quiz-v17 .pp-status-grid span { color:var(--navy); font-size:14px; font-weight:800; }
    #pp-quiz-v17 .pp-quantity { margin-top:16px; }
    #pp-quiz-v17 .pp-quantity-grid { display:grid; grid-template-columns:repeat(2,minmax(0,1fr)); gap:8px; }
    #pp-quiz-v17 .pp-quantity-choice { min-height:86px; flex-direction:column; justify-content:center; text-align:center; }
    #pp-quiz-v17 .pp-quantity-choice b { font-size:18px; }
    #pp-quiz-v17 .pp-quantity-choice span { color:var(--muted); font-size:13px; }
    @media(max-width:600px){#pp-quiz-v17 .pp-status-grid{grid-template-columns:1fr 1fr;}#pp-quiz-v17 .pp-quantity-grid{grid-template-columns:1fr;}#pp-quiz-v17 .pp-quantity-choice{min-height:90px;padding:8px 10px;font-size:14px;}}
    @media(max-width:360px){#pp-quiz-v17 .pp-status-grid{grid-template-columns:1fr;}#pp-quiz-v17 .pp-addon-copy{font-size:13px;}}
    #pp-quiz-v17 .pp-transition-screen { text-align:center; }
    #pp-quiz-v17 .pp-transition-image { display:block; width:min(100%,760px); height:auto; aspect-ratio:5 / 4; margin:0 auto 18px; object-fit:contain; object-position:center; background:#fff; border-radius:17px; box-shadow:0 12px 30px rgba(20,31,45,.09); }
    #pp-quiz-v17 .pp-transition-screen .pp-btn { width:min(100%,520px); margin:0 auto; }
    #pp-quiz-v17 { padding:0; background:#fff; font-size:16px; }
    #pp-quiz-v17 .pp-shell, #pp-quiz-v17.is-result-mode .pp-shell { width:100%; max-width:none; }
    #pp-quiz-v17 .pp-header { position:relative; z-index:20; justify-content:center; width:100%; min-height:64px; margin:0; padding:8px 40px; background:#fff; border-bottom:1px solid #eef0ec; }
    #pp-quiz-v17 .pp-quiz-brand { display:inline-flex; align-items:center; gap:9px; color:var(--navy); font-family:var(--head); font-size:20px; font-weight:900; text-decoration:none; }
    #pp-quiz-v17 .pp-logo { width:auto; height:34px; }
    #pp-quiz-v17 .pp-close { position:absolute; top:50%; right:28px; display:grid; place-items:center; width:42px; height:42px; color:var(--navy); border-radius:50%; font-size:31px; line-height:1; text-decoration:none; transform:translateY(-50%); }
    #pp-quiz-v17 .pp-card { overflow:visible; width:100%; margin:0; padding:0; background:#fff; border:0; border-radius:0; box-shadow:none; }
    #pp-quiz-v17 .pp-screen { width:330px; min-height:calc(100svh - 64px); margin:0 auto; padding:12px 0 32px; }
    #pp-quiz-v17 .pp-question h2 { margin:0 0 8px; font-size:22px !important; line-height:1.16 !important; text-align:center; }
    #pp-quiz-v17 .pp-question .pp-sub { margin:0 0 18px; font-size:16px !important; line-height:1.4 !important; text-align:center; }
    #pp-quiz-v17 .pp-topline { min-height:48px; margin-bottom:5px; }
    #pp-quiz-v17 .pp-back { min-height:48px !important; padding:8px 10px !important; font-size:14px !important; line-height:1 !important; }
    #pp-quiz-v17 .pp-progress { height:9px; margin-bottom:22px; }
    #pp-quiz-v17 .pp-field-wrap { position:relative; }
    #pp-quiz-v17 .pp-field-wrap .pp-label { position:absolute; top:5px; left:14px; z-index:2; margin:0; font-size:11px !important; line-height:1.2 !important; pointer-events:none; }
    #pp-quiz-v17 .pp-field { min-height:55px; padding:19px 14px 5px; font-size:16px !important; line-height:1.3 !important; border-width:1px; border-radius:8px; }
    #pp-quiz-v17 .pp-field-wrap small { display:block; margin-top:5px; color:var(--muted); font-size:12px; }
    #pp-quiz-v17 .pp-choice { min-height:48.4px; padding:10px 14px; border-width:1px; border-radius:999px; font-size:16px; }
    #pp-quiz-v17 .pp-choice b { font-size:16px !important; line-height:1.2 !important; }
    #pp-quiz-v17 .pp-choice small { margin-top:2px; font-size:12px !important; line-height:1.25 !important; }
    #pp-quiz-v17 .pp-choice-check { flex-basis:22px; width:22px; height:22px; border-width:1.5px; font-size:12px; }
    #pp-quiz-v17 .pp-inline-choice { margin-top:0; }
    #pp-quiz-v17 .pp-or { margin:14px 0; color:var(--muted); font-size:12px; font-weight:900; text-align:center; }
    #pp-quiz-v17 .pp-second-question { margin-top:34px !important; }
    #pp-quiz-v17 .pp-two-up { grid-template-columns:repeat(2,1fr); gap:16px; }
    #pp-quiz-v17 .pp-two-up .pp-choice { min-height:88.4px; align-items:center; justify-content:center; text-align:center; }
    #pp-quiz-v17 .pp-btn { min-height:54.2px; padding:13px 20px; font-size:17px; box-shadow:none; }
    #pp-quiz-v17 .pp-next { margin-top:40px; }
    #pp-quiz-v17 .pp-age-help { margin:0 0 10px; color:var(--muted); font-size:13px !important; line-height:1.35 !important; text-align:center; }
    #pp-quiz-v17 .pp-age-fields { gap:16px; }
    #pp-quiz-v17 .pp-size-grid { grid-template-columns:repeat(2,1fr); gap:8px; }
    #pp-quiz-v17 .pp-size-grid .pp-choice { min-height:94.4px; align-items:center; justify-content:center; padding:8px; text-align:center; }
    #pp-quiz-v17 .pp-dog-size { display:grid; place-items:center; width:48px; height:42px; color:var(--blue); line-height:1; }
    #pp-quiz-v17 .pp-dog-size svg { display:block; width:48px; height:42px; transform-origin:50% 100%; }
    #pp-quiz-v17 .pp-size-choice small { font-size:12px; }
    #pp-quiz-v17 .pp-concern-label { display:block; margin-bottom:7px; color:var(--blue); font-size:14px !important; line-height:1.3 !important; font-weight:900; text-align:center; }
    #pp-quiz-v17 .pp-select-copy { margin:0 0 14px; color:var(--muted); font-size:13px !important; line-height:1.35 !important; text-align:center; }
    #pp-quiz-v17 .pp-concern-choices { gap:12px; }
    #pp-quiz-v17 .pp-education-note { display:block; margin:30px 0 0; padding:0; color:var(--navy); background:transparent; border:0; border-radius:0; text-align:center; }
    #pp-quiz-v17 .pp-education-note h3 { margin:0 0 8px; font-size:18px !important; line-height:1.25 !important; }
    #pp-quiz-v17 .pp-education-note p { margin:0; color:var(--muted); font-size:14px !important; line-height:1.42 !important; }
    #pp-quiz-v17 .pp-consent, #pp-quiz-v17 .pp-consent span { font-size:14px !important; line-height:1.5 !important; }
    #pp-quiz-v17 .pp-intro-screen { display:flex; flex-direction:column; position:relative; width:100%; min-height:calc(100svh - 64px); padding:96px 16px 24px; }
    #pp-quiz-v17 .pp-intro-screen > .pp-topline { position:absolute; top:0; right:calc(50% - 330px); left:calc(50% - 330px); z-index:3; }
    #pp-quiz-v17 .pp-intro-screen > .pp-progress { position:absolute; top:53px; right:calc(50% - 330px); left:calc(50% - 330px); z-index:3; }
    #pp-quiz-v17 .pp-intro-content { position:relative; z-index:2; width:min(100%,648px); margin:0 auto; text-align:center; }
    #pp-quiz-v17 .pp-intro-content h1 { margin:0; font-size:44px !important; line-height:1.1 !important; }
    #pp-quiz-v17 .pp-intro-content h1 em { display:block; color:var(--blue); font-family:Georgia,serif; font-weight:500; }
    #pp-quiz-v17 .pp-intro-content > .pp-sub { margin:14px auto 18px; max-width:648px; font-size:16px !important; line-height:1.4 !important; }
    #pp-quiz-v17 .pp-intro-form { width:320px; margin:22px auto 0; }
    #pp-quiz-v17 .pp-intro-form h2 { margin:0 0 8px; font-size:21px !important; line-height:1.2 !important; }
    #pp-quiz-v17 .pp-intro-form .pp-next { margin-top:32px; }
    #pp-quiz-v17 .pp-intro-media { order:2; width:min(100%,1020px); margin:28px auto 0; }
    #pp-quiz-v17 .pp-question-hero { display:block; position:static; width:100%; height:auto; max-height:400px; aspect-ratio:auto; object-fit:contain; opacity:1; pointer-events:none; }
    #pp-quiz-v17 .pp-quiz-products { display:grid; grid-template-columns:repeat(3,minmax(0,1fr)); gap:12px; width:min(100%,640px); margin:0 auto; }
    #pp-quiz-v17 .pp-quiz-products-single { grid-template-columns:minmax(0,1fr); width:min(100%,240px); }
    #pp-quiz-v17 .pp-quiz-products figure { min-width:0; margin:0; }
    #pp-quiz-v17 .pp-quiz-products img { display:block; width:100%; height:auto; aspect-ratio:1 / 1; object-fit:contain; }
    #pp-quiz-v17 .pp-quiz-products figcaption { margin-top:6px; font-size:14px !important; line-height:1.3 !important; font-weight:700; text-align:center; }
    #pp-quiz-v17 .pp-intro-form small { display:block; margin-top:8px; font-size:13px !important; line-height:1.4 !important; }
    #pp-quiz-v17.is-result-mode .pp-card { width:870px; max-width:100%; margin:0 auto; }
    #pp-quiz-v17 .pp-result-screen { width:100%; min-height:auto; padding:58px 0 90px; }
    #pp-quiz-v17 .pp-result-screen > .pp-center { text-align:left; }
    #pp-quiz-v17 .pp-result-screen h1 { margin:0 0 24px; font-size:25px !important; line-height:1.2 !important; }
    #pp-quiz-v17 .pp-health-panel { padding:30px 32px; border:1px solid var(--line); border-radius:16px; }
    #pp-quiz-v17 .pp-profile-grid { margin:0 0 24px; gap:0; }
    #pp-quiz-v17 .pp-profile-grid .pp-dose-cell { align-items:flex-start; min-height:48px; padding:0 12px; background:transparent; border:0; border-right:1px solid var(--line); border-radius:0; text-align:left; }
    #pp-quiz-v17 .pp-profile-grid .pp-dose-cell:first-child { padding-left:0; }
    #pp-quiz-v17 .pp-profile-grid .pp-dose-cell:last-child { padding-right:0; border-right:0; }
    #pp-quiz-v17 .pp-profile-grid .pp-dose-cell span { order:1; margin:2px 0 0; font-size:13px; font-weight:500; letter-spacing:0; text-transform:none; }
    #pp-quiz-v17 .pp-profile-grid .pp-dose-cell b { order:0; color:var(--navy); font-family:var(--body); font-size:15px; }
    #pp-quiz-v17 .pp-health-intro { margin:0 0 18px; color:var(--navy); font-size:14px !important; line-height:1.4 !important; }
    #pp-quiz-v17 .pp-health-categories { gap:20px; }
    #pp-quiz-v17 .pp-health-category { min-height:58px; flex-direction:row; justify-content:flex-start; gap:10px; padding:0; background:transparent; border:0; border-radius:0; text-align:left; }
    #pp-quiz-v17 .pp-health-category-icon { flex:0 0 48px; width:48px; height:48px; margin:0; color:#f0a000; background:#fff5df; border:0; font-family:Arial,sans-serif; font-size:24px; }
    #pp-quiz-v17 .pp-health-category-icon.is-clear { color:#0a9a34; background:#e9f8e9; }
    #pp-quiz-v17 .pp-health-category-count { top:0; left:36px; right:auto; min-width:18px; height:18px; padding:0 4px; background:#ffa000; font-size:10px; }
    #pp-quiz-v17 .pp-health-category b { font-family:var(--body); font-size:14px; }
    #pp-quiz-v17 .pp-quiz-videos { margin:44px 0 0; }
    #pp-quiz-v17 .pp-quiz-videos-header { margin:0 0 20px; }
    #pp-quiz-v17 .pp-quiz-videos-header span { display:block; margin-bottom:6px; color:var(--blue); font-size:12px; font-weight:900; letter-spacing:.1em; text-transform:uppercase; }
    #pp-quiz-v17 .pp-quiz-videos-header h2 { margin:0 0 7px; font-size:25px !important; line-height:1.2 !important; }
    #pp-quiz-v17 .pp-quiz-videos-header p { margin:0; color:var(--muted); font-size:15px !important; line-height:1.4 !important; }
    #pp-quiz-v17 .pp-quiz-videos-grid { display:grid; grid-template-columns:repeat(2,minmax(0,1fr)); gap:20px; }
    #pp-quiz-v17 .pp-quiz-video { overflow:hidden; margin:0; background:#f5f8fd; border:1px solid var(--line); border-radius:18px; }
    #pp-quiz-v17 .pp-quiz-video video { display:block; width:100%; aspect-ratio:9 / 16; max-height:540px; background:#06152f; object-fit:contain; }
    #pp-quiz-v17 .pp-quiz-video figcaption { min-height:58px; padding:14px 16px; color:var(--navy); font-size:14px; font-weight:900; line-height:1.35; }
    #pp-quiz-v17 .pp-recommendations { margin-top:54px; }
    #pp-quiz-v17 .pp-recommendations-intro { margin-bottom:32px; }
    #pp-quiz-v17 .pp-recommendations-intro h2 { margin:0 0 8px; font-size:25px !important; line-height:1.2 !important; text-align:left; }
    #pp-quiz-v17 .pp-recommendations-intro p { margin:0; color:var(--muted); font-size:15px !important; line-height:1.4 !important; }
    #pp-quiz-v17 .pp-bundle-intro, #pp-quiz-v17 .pp-single-intro { margin:0 0 24px; font-family:var(--body); font-size:16px; font-weight:900; }
    #pp-quiz-v17 .pp-single-intro { margin-top:56px; padding-top:56px; border-top:1px solid var(--line); }
    #pp-quiz-v17 .pp-recommendation-card { display:grid; grid-template-columns:422.5px 422.5px; align-items:start; gap:24px; overflow:visible; margin:0 0 34px; background:transparent; border:0; border-radius:0; box-shadow:none; }
    #pp-quiz-v17 .pp-recommendation-card.is-bundle { border:0; }
    #pp-quiz-v17 .pp-recommendation-card .pp-gallery { width:422.5px; padding-bottom:44px; border:0; border-radius:22px; box-shadow:none; }
    #pp-quiz-v17 .pp-recommendation-copy { padding:12px 0 0; }
    #pp-quiz-v17 .pp-recommendation-copy .pp-badge { margin-bottom:10px; color:var(--navy); background:var(--blue-soft); font-size:11px; }
    #pp-quiz-v17 .pp-recommendation-copy h3 { margin:0 0 8px; font-size:22px !important; line-height:1.2 !important; }
    #pp-quiz-v17 .pp-recommendation-copy p { font-size:15px !important; line-height:1.4 !important; }
    #pp-quiz-v17 .pp-recommendation-benefits { gap:7px; margin:14px 0; }
    #pp-quiz-v17 .pp-recommendation-benefits li { gap:8px; font-size:14px !important; line-height:1.35 !important; }
    #pp-quiz-v17 .pp-recommendation-benefits li span { width:auto; height:auto; flex-basis:auto; color:#0a8f2b; background:transparent; font-size:16px; }
    #pp-quiz-v17 .pp-recommendation-price { margin:10px 0; }
    #pp-quiz-v17 .pp-recommendation-price b { color:var(--blue); font-family:var(--body); font-size:21px; }
    #pp-quiz-v17 .pp-choose-package { margin-top:12px; }
    #pp-quiz-v17 .pp-learn-more { font-size:15px; text-decoration:underline; }
    #pp-quiz-v17 .pp-gallery { position:relative; }
    #pp-quiz-v17 .pp-gallery-controls { position:absolute; inset:0; display:block; padding:0; pointer-events:none; }
    #pp-quiz-v17 .pp-gallery-arrow { position:absolute; top:calc(50% - 22px); z-index:3; width:54px; height:54px; background:rgba(255,255,255,.94); border:0; pointer-events:auto; transform:translateY(-50%); }
    #pp-quiz-v17 .pp-gallery-arrow[data-gallery-prev] { left:16px; }
    #pp-quiz-v17 .pp-gallery-arrow[data-gallery-next] { right:16px; }
    #pp-quiz-v17 .pp-gallery-dots { position:absolute; bottom:7px; left:50%; z-index:3; flex-wrap:nowrap; gap:8px; padding:7px 12px; background:#fff; border-radius:999px; pointer-events:auto; transform:translateX(-50%); }
    #pp-quiz-v17 .pp-gallery-dot { width:11px; height:11px; }
    #pp-quiz-v17 .pp-gallery-slide img { aspect-ratio:1 / 1; }
    #pp-quiz-v17 .pp-offer-grid { width:660px; max-width:100%; margin:42px auto; }
    #pp-quiz-v17 .pp-result-screen > .pp-retake { margin-top:42px; }
    @media (max-width: 900px) and (min-width: 701px) {
      #pp-quiz-v17 .pp-recommendation-card { grid-template-columns:minmax(0,1fr) minmax(0,1fr); }
      #pp-quiz-v17 .pp-recommendation-card .pp-gallery { width:100%; max-width:100%; }
      #pp-quiz-v17 .pp-recommendation-copy { min-width:0; }
    }
    @media (max-width: 700px) {
      #pp-quiz-v17 .pp-header { min-height:48px; padding:4px 48px; }
      #pp-quiz-v17 .pp-quiz-brand { font-size:18px; }
      #pp-quiz-v17 .pp-logo { height:28px; }
      #pp-quiz-v17 .pp-close { right:8px; width:40px; height:40px; font-size:28px; }
      #pp-quiz-v17 .pp-screen { min-height:calc(100svh - 48px); }
      #pp-quiz-v17 .pp-intro-screen { width:100%; padding:86px 16px 28px; }
      #pp-quiz-v17 .pp-intro-screen > .pp-topline { right:16px; left:16px; }
      #pp-quiz-v17 .pp-intro-screen > .pp-progress { right:16px; left:16px; }
      #pp-quiz-v17 .pp-intro-media { display:block; }
      #pp-quiz-v17 .pp-intro-content { width:343px; max-width:100%; }
      #pp-quiz-v17 .pp-intro-content h1 { font-size:34px !important; }
      #pp-quiz-v17 .pp-intro-form { width:100%; }
      #pp-quiz-v17 .pp-question-narrow { width:343px; max-width:calc(100% - 32px); }
      #pp-quiz-v17.is-result-mode .pp-card { width:375px; max-width:100%; }
      #pp-quiz-v17 .pp-result-screen { padding:16px 0 64px; }
      #pp-quiz-v17 .pp-result-screen > .pp-center, #pp-quiz-v17 .pp-recommendations-intro, #pp-quiz-v17 .pp-bundle-intro, #pp-quiz-v17 .pp-single-intro { padding-right:16px; padding-left:16px; }
      #pp-quiz-v17 .pp-result-screen h1 { margin-bottom:16px; font-size:22px !important; }
      #pp-quiz-v17 .pp-health-panel { padding:18px 16px; }
      #pp-quiz-v17 .pp-health-categories { gap:4px; }
      #pp-quiz-v17 .pp-health-category { min-height:94px; flex-direction:column; justify-content:flex-start; gap:6px; text-align:center; }
      #pp-quiz-v17 .pp-health-category-icon { flex-basis:48px; }
      #pp-quiz-v17 .pp-health-category-count { left:calc(50% + 10px); }
      #pp-quiz-v17 .pp-health-category b { font-size:13px; line-height:1.2; }
      #pp-quiz-v17 .pp-quiz-videos { margin-top:34px; padding-right:16px; padding-left:16px; }
      #pp-quiz-v17 .pp-quiz-videos-grid { grid-template-columns:1fr; gap:16px; }
      #pp-quiz-v17 .pp-quiz-video video { max-height:520px; }
      #pp-quiz-v17 .pp-recommendations { margin-top:34px; }
      #pp-quiz-v17 .pp-recommendations-intro { margin-bottom:34px; }
      #pp-quiz-v17 .pp-recommendations-intro h2 { font-size:22px !important; }
      #pp-quiz-v17 .pp-bundle-intro { margin-bottom:24px; }
      #pp-quiz-v17 .pp-recommendation-card { display:block; margin-bottom:40px; }
      #pp-quiz-v17 .pp-recommendation-card .pp-gallery { width:100%; border-radius:0; }
      #pp-quiz-v17 .pp-recommendation-copy { padding:18px 16px 0; }
      #pp-quiz-v17 .pp-single-intro { margin-top:40px; padding-top:40px; }
      #pp-quiz-v17 .pp-gallery-arrow { width:48px; height:48px; }
      #pp-quiz-v17 .pp-offer-grid { width:auto; margin:32px 16px; }
      #pp-quiz-v17 .pp-result-screen > .pp-retake { margin-left:16px; }
      #pp-quiz-v17 .pp-sticky-result-cta { display:none; }
    }
    @media (prefers-reduced-motion: reduce) {
      #pp-quiz-v17 *, #pp-quiz-v17 *::before, #pp-quiz-v17 *::after { scroll-behavior: auto !important; transition: none !important; animation: none !important; }
    }
  `;

  if (!document.getElementById("pp-quiz-v17-styles")) {
    var style = document.createElement("style");
    style.id = "pp-quiz-v17-styles";
    style.textContent = CSS;
    document.head.appendChild(style);
  }

  document.body.classList.add("pp-quiz-v17-page");
  mount.innerHTML =
    '<div id="pp-quiz-v17">' +
    '<div class="pp-shell">' +
    '<header class="pp-header">' +
    '<a class="pp-quiz-brand" href="/" aria-label="PuzzlePup home"><img class="pp-logo" decoding="async" src="' +
    escapeAttribute(
      window.PP_QUIZ_LOGO_URL ||
        asset("puzzlepup-funnel-quiz-logo-2026-07.webp"),
    ) +
    '" alt="" width="160" height="113"><span>PuzzlePup Quiz</span></a>' +
    '<a class="pp-close" href="/" aria-label="Close quiz">×</a>' +
    "</header>" +
    '<main class="pp-card" id="pp-quiz-stage" aria-live="polite"></main>' +
    "</div></div>";

  var root = document.getElementById("pp-quiz-v17");
  var stage = document.getElementById("pp-quiz-stage");
  var entryGoal = normalizeEntryGoal(window.PP_QUIZ_ENTRY_GOAL);
  var internalQaInfo = detectInternalQa();
  var campaign = getActiveCampaign();
  var storageKey = "pp_quiz_v36_" + (entryGoal || "general");
  var currentScreen = "intro";
  var selectedPlan = null;
  var selectedJarQuantity = 2;
  var selectedAddons = { campaignJar: false, snuffleMat: false };
  var selectedResultProductKey = null;
  var selectedPackageOpen = false;
  var resultTracked = false;
  var viewSequence = 0;
  var answers = {
    goal: entryGoal || "",
    details: [],
    weight: null,
    weightBand: "",
    exactWeight: "",
    approach: "",
    signal: "",
    pattern: "",
    impact: "",
    dogName: "",
    email: "",
    breed: "",
    gender: "",
    age: "",
    ageYears: "",
    ageMonths: "",
    ageUnknown: false,
    showExactWeight: false,
    dental: [],
    skin: [],
    allergy: [],
    gut: [],
    mobility: [],
    emailStatus: "not_seen",
    emailConsent: false,
  };

  restoreProgress();
  if (entryGoal) answers.goal = entryGoal;
  validateRestoredState();

  var QUIZ_SCREENS = ["intro","profile","ageweight","skin","allergy","gut","mobility","email"];
  var CONCERNS = {
    skin: {
      step: 4,
      label: "Skin & Coat",
      title: "How is the skin and fluff looking?",
      copy: "Select all that apply",
      noteTitle: "The coat leaves clues...",
      note: "Tell us what you have noticed about your dog’s skin and coat.",
      options: [["shedding","Extra shedding"],["flakes","Dry or flaky skin"],["dull","Dull coat"],["rough","Rough-feeling fur"],["none","None of the above"]],
      next: "allergy",
      back: "ageweight"
    },
    allergy: {
      step: 5,
      label: "Allergy & Itch",
      title: "Which of these have you noticed?",
      copy: "Select all that apply",
      noteTitle: "The itch does not need an invitation...",
      note: "Tell us what you have noticed. These answers help organize product choices; they do not identify what is causing the signs.",
      options: [["thin_dull","Thin or dull coat"],["head_shaking","Head shaking"],["paw_licking","Paw licking"],["scratching","Scratching"],["ear_discomfort","Bothered ears"],["none","None of the above"]],
      next: "gut",
      back: "skin"
    },
    gut: {
      step: 6,
      label: "Belly",
      title: "Does the belly add any clues?",
      copy: "Select all that apply",
      noteTitle: "Let’s check on their belly, too.",
      note: "These observations add context to your product matches. The quiz cannot determine the cause of belly or digestion concerns.",
      options: [["discomfort","Bothered belly or gas"],["stool","Inconsistent poop"],["low_immunity","Catches every little bug"],["anal","Anal gland trouble"],["scooting","Scooting"],["none","None of the above"]],
      next: "mobility",
      back: "allergy"
    },
    mobility: {
      step: 7,
      label: "Movement",
      title: "Lastly, how is the get-up-and-go?",
      copy: "Select all that apply",
      noteTitle: "Easy movement matters at every age...",
      note: "Your answers help you compare the joint formula with the other products. A quiz result is not a diagnosis or a promise of improvement.",
      options: [["discomfort","Occasional discomfort"],["stiffness","Stiffness"],["flexibility","Reduced flexibility"],["none","None of the above"]],
      next: "email",
      back: "gut"
    }
  };
  var sessionId = getSessionId();
  var attemptId = createId("attempt");

  render();

  function escapeHtml(value) {
    return String(value == null ? "" : value).replace(
      /[&<>"']/g,
      function (char) {
        return {
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#39;",
        }[char];
      },
    );
  }

  function escapeAttribute(value) {
    return escapeHtml(value);
  }

  function createId(prefix) {
    try {
      if (window.crypto && typeof window.crypto.randomUUID === "function") {
        return prefix + "_" + window.crypto.randomUUID();
      }
    } catch (error) {}
    return (
      prefix +
      "_" +
      Date.now().toString(36) +
      "_" +
      Math.random().toString(36).slice(2, 11)
    );
  }

  function getSessionId() {
    var key = "pp_quiz_session_v17";
    try {
      var existing = sessionStorage.getItem(key);
      if (existing) return existing;
      var created = createId("session");
      sessionStorage.setItem(key, created);
      return created;
    } catch (error) {
      return createId("session");
    }
  }

  function detectInternalQa() {
    var reasons = [];
    try {
      var params = new URLSearchParams(window.location.search || "");
      if (params.has("pp_internal")) {
        var internalValue = String(params.get("pp_internal") || "").trim();
        if (internalValue === "0") {
          localStorage.removeItem("pp_internal");
          localStorage.removeItem("pp_internal_traffic");
          sessionStorage.removeItem("pp_quiz_internal_qa");
        } else {
          reasons.push("query:pp_internal");
          if (internalValue === "1") localStorage.setItem("pp_internal", "1");
        }
      }
      ["ppqa", "pp_audit", "qa", "verify", "ppverify"].forEach(function (key) {
        if (params.has(key)) reasons.push("query:" + key);
      });
      if (String(params.get("utm_source") || "").toLowerCase() === "codex_qa") {
        reasons.push("utm_source:codex_qa");
      }
      if (params.has("preview_theme_id")) {
        reasons.push("query:preview_theme_id");
      }
      if (reasons.length) sessionStorage.setItem("pp_quiz_internal_qa", "1");
      if (sessionStorage.getItem("pp_quiz_internal_qa") === "1") {
        reasons.push("qa_session");
      }
      if (
        localStorage.getItem("pp_internal") === "1" ||
        localStorage.getItem("pp_internal_traffic") === "1"
      ) {
        reasons.push("internal_storage");
      }
    } catch (error) {}
    try {
      if (window.Shopify && window.Shopify.designMode)
        reasons.push("shopify_design_mode");
      if (
        window.Shopify &&
        window.Shopify.theme &&
        window.Shopify.theme.role &&
        String(window.Shopify.theme.role).toLowerCase() !== "main"
      ) {
        reasons.push("shopify_theme_role:" + window.Shopify.theme.role);
      }
      if (/shopifypreview\.com$/i.test(window.location.hostname || "")) {
        reasons.push("shopify_preview");
      }
    } catch (error) {}
    return { value: reasons.length > 0, reasons: unique(reasons) };
  }

  function unique(values) {
    return values.filter(function (value, index) {
      return values.indexOf(value) === index;
    });
  }

  function getActiveCampaign() {
    return null;
  }

  function campaignCode() {
    return "";
  }

  function campaignSecondJarProduct(primaryProduct, recommendation, refill) {
    return null;
  }

  function campaignMarkup() {
    return "";
  }

  function commonEventPayload() {
    var params;
    var source = "";
    try {
      params = new URLSearchParams(window.location.search || "");
      source = params.get("utm_source") || "";
    } catch (error) {}
    return {
      event_category: "dog_match_quiz",
      quiz_id: CONFIG.quizId,
      quiz_version: CONFIG.quizVersion,
      quiz_session_id: sessionId,
      quiz_attempt_id: attemptId,
      entry_goal: entryGoal || null,
      internal_qa: internalQaInfo.value,
      internal_qa_reason: internalQaInfo.reasons.join(",") || null,
      traffic_type: internalQaInfo.value ? "internal_qa" : "customer",
      utm_source: source || null,
      campaign_active: Boolean(campaign),
      event_timestamp: new Date().toISOString(),
    };
  }

  function emit(eventName, payload) {
    var data = Object.assign(commonEventPayload(), payload || {});
    var eventRecord = Object.assign({ event: eventName }, data);
    if (internalQaInfo.value) {
      publicApi.qaEvents.push(eventRecord);
      try {
        document.dispatchEvent(
          new CustomEvent("puzzlepup:quiz-qa-event", { detail: eventRecord }),
        );
      } catch (error) {}
      return;
    }
    try {
      if (
        window.PuzzlePupAnalytics &&
        typeof window.PuzzlePupAnalytics.track === "function"
      ) {
        var trackResult = window.PuzzlePupAnalytics.track(eventName, data);
        if (trackResult && typeof trackResult.catch === "function")
          trackResult.catch(function () {});
      } else {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(eventRecord);
      }
    } catch (error) {}
  }

  function saveProgress() {
    try {
      localStorage.setItem(
        storageKey,
        JSON.stringify({
          savedAt: Date.now(),
          screen: currentScreen,
          answers: answers,
        }),
      );
    } catch (error) {}
  }

  function restoreProgress() {
    try {
      var raw = localStorage.getItem(storageKey);
      if (!raw) return;
      var saved = JSON.parse(raw);
      if (
        !saved ||
        !saved.answers ||
        Date.now() - Number(saved.savedAt || 0) > 604800000
      ) {
        return;
      }
      answers = Object.assign(answers, saved.answers);
      if (Array.isArray(saved.answers.details)) {
        answers.details = saved.answers.details.slice(0, 4);
      } else {
        answers.details = [];
      }
      currentScreen = String(saved.screen || "intro");
    } catch (error) {}
  }

  function validateRestoredState() {
    var allowedScreens = ["intro","profile","ageweight","skin","allergy","gut","mobility","email","result"];
    if (allowedScreens.indexOf(currentScreen) < 0) currentScreen = "intro";
    ["dental","skin","allergy","gut","mobility"].forEach(function(key){
      if (!Array.isArray(answers[key])) answers[key] = [];
    });
    answers.details = Array.isArray(answers.details) ? answers.details : [];
    ["approach","signal","pattern","impact","dogName","age","ageYears","ageMonths","email","breed","gender","weightBand","exactWeight"].forEach(function(key){
      answers[key] = String(answers[key] || "");
    });
    var weight = Number(answers.weight);
    answers.weight = refillForWeight(weight) ? weight : null;
    answers.emailStatus = String(answers.emailStatus || "not_seen");
    answers.emailConsent = Boolean(answers.emailConsent);
    answers.ageUnknown = Boolean(answers.ageUnknown);
    answers.showExactWeight = Boolean(answers.showExactWeight);
    if (entryGoal) answers.goal = entryGoal;
    if (currentScreen === "result") {
      if (!answers.dogName || !answers.breed || !answers.gender || (!answers.ageUnknown && !answers.ageYears && !answers.ageMonths) || !answers.weight || !answers.skin.length || !answers.allergy.length || !answers.gut.length || !answers.mobility.length || answers.emailStatus === "not_seen") {
        currentScreen = "intro";
      }
    }
  }
  function questionHeader(step, backScreen) {
    var total = 8;
    return '<div class="pp-topline"><button class="pp-back" type="button" data-back="'+escapeAttribute(backScreen)+'" aria-label="Go back">‹ Back</button><span class="pp-step-count">Question '+step+' of '+total+'</span></div>'+
      '<div class="pp-progress" role="progressbar" aria-valuemin="1" aria-valuemax="'+total+'" aria-valuenow="'+step+'" aria-label="Question '+step+' of '+total+'"><span style="width:'+(step/total)*100+'%"></span></div>';
  }
  function setScreen(screen, options) {
    var previous=currentScreen; currentScreen=screen; saveProgress();
    if(options&&options.back) emit("quiz_back",{from_screen:previous,to_screen:screen,completed_questions:completedQuestionCount()});
    render(); scrollToQuiz();
  }
  function scrollToQuiz(){try{root.scrollIntoView({behavior:(window.matchMedia&&window.matchMedia("(prefers-reduced-motion: reduce)").matches)?"auto":"smooth",block:"start"});}catch(error){}}
  function completedQuestionCount(){
    var count=0;
    if(answers.dogName) count++;
    if(answers.breed&&answers.gender) count++;
    if((answers.ageUnknown||answers.ageYears||answers.ageMonths)&&refillForWeight(answers.weight)) count++;
    if(answers.skin.length) count++;
    if(answers.allergy.length) count++;
    if(answers.gut.length) count++;
    if(answers.mobility.length) count++;
    if(answers.emailStatus !== "not_seen") count++;
    return count;
  }
  function render(){
    viewSequence+=1;
    root.classList.toggle("is-result-mode",currentScreen==="result");
    var map={
      intro:renderIntroV36,
      profile:renderProfileV36,
      ageweight:renderAgeWeightV36,
      skin:function(){renderConcernV36("skin");},
      allergy:function(){renderConcernV36("allergy");},
      gut:function(){renderConcernV36("gut");},
      mobility:function(){renderConcernV36("mobility");},
      email:renderEmailV36,
      result:renderResult
    };
    (map[currentScreen]||renderIntroV36)();
    bindSharedEvents(); trackScreenView(); focusScreenHeading();
  }
  function focusScreenHeading(){try{var heading=stage.querySelector("h1,h2");if(heading){heading.setAttribute("tabindex","-1");heading.focus({preventScroll:true});}}catch(error){}}
  function trackScreenView(){
    var payload={screen:currentScreen,view_sequence:viewSequence,completed_questions:completedQuestionCount()};
    if(currentScreen==="intro") emit("quiz_view",Object.assign(payload,{step:1,total_visible_questions:8,step_id:"name"}));
    else if(currentScreen==="email"){
      payload.step=8;payload.total_visible_questions=8;payload.step_id="email";emit("quiz_email_view",payload);
    }
    else if(QUIZ_SCREENS.indexOf(currentScreen)>=0){payload.step=QUIZ_SCREENS.indexOf(currentScreen)+1;payload.total_visible_questions=8;payload.step_id=currentScreen;emit("quiz_step_view",payload);}
    else if(currentScreen==="result"&&!resultTracked){resultTracked=true;emit("quiz_result",Object.assign(payload,recommendationEventData()));}
  }
  function bindSharedEvents(){
    var back=stage.querySelector("[data-back]");
    if(back) back.addEventListener("click",function(){setScreen(back.getAttribute("data-back"),{back:true});});
    stage.querySelectorAll("[data-product-link]").forEach(function(link){link.addEventListener("click",function(){emit("quiz_product_click",{product_role:link.getAttribute("data-product-role")||"primary",product_key:link.getAttribute("data-product-key"),product_url:link.getAttribute("href")});});});
  }
  function introProductsMarkup(productKey) {
    var keys=productKey?[productKey]:["A","J","S"];
    return '<div class="pp-quiz-products'+(productKey?' pp-quiz-products-single':'')+'" role="group" aria-label="PuzzlePup supplement formulas">'+keys.map(function(key){
      var product=PRODUCTS[key];
      return '<figure><img '+responsiveImageAttributes(product.productImg,[160,240,360,480],"(max-width: 600px) 30vw, 200px")+' alt="'+escapeAttribute(product.heroAlt)+'" width="480" height="480" loading="eager" decoding="async"><figcaption>'+escapeHtml(product.name)+'</figcaption></figure>';
    }).join('')+'</div>';
  }

  function renderIntro(){
    var targeted=entryGoal?GOALS[entryGoal]:GOALS.wellness;
    var introKey=entryGoal==="allergy"?"A":entryGoal==="joint"?"J":entryGoal==="skin"?"S":null;
    stage.innerHTML='<section class="pp-screen pp-center">'+introProductsMarkup(introKey)+
      '<span class="pp-eyebrow">Dog-mom product finder</span><h1>'+escapeHtml(entryGoal?targeted.introTitle:"What’s bugging your bestie?")+'</h1>'+
      '<p class="pp-sub">'+escapeHtml(targeted.introCopy)+'</p>'+
      '<button class="pp-btn" type="button" data-start>Let’s solve it →</button>'+
      '<div class="pp-outcomes"><div class="pp-outcome"><b>8</b> Quick taps</div><div class="pp-outcome"><b>1</b> Clear jar</div><div class="pp-outcome"><b>$49.99</b> Pick your pair</div></div>'+ 
      '<div class="pp-trust"><span>🩺 Weight-based label directions</span><span>🇺🇸 Approximately 60 soft chews</span><span>🛡️ 30-day money-back promise</span></div></section>';
    stage.querySelector("[data-start]").addEventListener("click",function(){emit("quiz_start",{start_path:entryGoal?"targeted":"general",preselected_goal:entryGoal||null});setScreen("name");});
  }

  function renderName(){
    stage.innerHTML='<section class="pp-screen pp-question">'+questionHeader(1,"intro")+
      '<h2>First things first—what’s your dog’s name?</h2><p class="pp-sub">Every excellent game plan deserves their name on it.</p>'+
      '<div class="pp-field-wrap"><label class="pp-label" for="pp-dog-name">My bestie is called…</label><input class="pp-field" id="pp-dog-name" type="text" maxlength="40" autocomplete="off" value="'+escapeAttribute(answers.dogName)+'"></div>'+
      '<button class="pp-btn pp-next" type="button" data-next'+(answers.dogName?"":" disabled")+'>That’s my pup →</button></section>';
    var field=stage.querySelector("#pp-dog-name");
    var next=stage.querySelector("[data-next]");
    field.addEventListener("input",function(){next.disabled=!field.value.trim();});
    next.addEventListener("click",function(){var value=field.value.trim();if(!value)return;answers.dogName=value;emit("quiz_answer",{step:1,step_id:"name"});setScreen("age");});
  }

  function renderAge(){
    var options=[
      ["puppy","Under 1","Professional sock thief"],
      ["young","1–3 years","Zoomie department"],
      ["adult","4–7 years","Prime-time bestie"],
      ["senior","8+ years","Distinguished cuddle boss"]
    ];
    stage.innerHTML='<section class="pp-screen pp-question">'+questionHeader(2,"name")+
      '<h2>How old is '+escapeHtml(answers.dogName||"your pup")+'?</h2><p class="pp-sub">Age helps us read those little clues without making it weird.</p><div class="pp-choices">'+
      options.map(function(option){var on=answers.age===option[0];return '<button type="button" class="pp-choice'+(on?" is-selected":"")+'" data-age="'+option[0]+'"><span><b>'+option[1]+'</b><small>'+option[2]+'</small></span><span class="pp-choice-check">'+(on?"✓":"")+'</span></button>';}).join("")+
      '</div><button class="pp-btn pp-next" type="button" data-next'+(answers.age?"":" disabled")+'>Got it →</button></section>';
    stage.querySelectorAll("[data-age]").forEach(function(button){button.addEventListener("click",function(){answers.age=button.getAttribute("data-age");emit("quiz_answer",{step:2,step_id:"age",answer_value:answers.age});renderAge();bindSharedEvents();});});
    var next=stage.querySelector("[data-next]");if(next)next.addEventListener("click",function(){if(answers.age)setScreen("signal");});
  }

  function resetSignalAnswers(){
    answers.details=[];
    answers.allergy=[];
    answers.gut=[];
    answers.mobility=[];
    answers.pattern="";
    answers.impact="";
  }
  function signalOptions(){
    if(!entryGoal){
      return [
        {id:"allergy",icon:"🐾",label:"Scratch, paw-lick, or head-shake drama",goal:"allergy",detail:"itch_scratching"},
        {id:"joint",icon:"🦴",label:"Slow starts, stair pauses, or skipped jumps",goal:"joint",detail:"joint_stiffness"},
        {id:"skin",icon:"✨",label:"Fur tumbleweeds, flakes, or missing shine",goal:"skin",detail:"skin_shedding"}
      ];
    }
    if(entryGoal==="allergy"){
      return [
        {id:"itch_scratching",icon:"🐾",label:"The scratch-and-rub encore",goal:"allergy",detail:"itch_scratching"},
        {id:"itch_paws",icon:"👅",label:"Paws suddenly became a snack",goal:"allergy",detail:"itch_scratching"},
        {id:"itch_ears",icon:"👂",label:"The head-shake remix",goal:"allergy",detail:"itch_ears"},
        {id:"itch_skin",icon:"🔴",label:"Bothered-looking skin",goal:"allergy",detail:"itch_scratching"}
      ];
    }
    if(entryGoal==="joint"){
      return [
        {id:"joint_stiffness",icon:"🐢",label:"Slow-motion after naps",goal:"joint",detail:"joint_stiffness"},
        {id:"joint_stairs",icon:"🪜",label:"Stairs became a committee meeting",goal:"joint",detail:"joint_stairs"},
        {id:"joint_walks",icon:"🐕",label:"Walks got shorter and slower",goal:"joint",detail:"joint_stiffness"},
        {id:"joint_jumps",icon:"🛋️",label:"The ‘do I have to jump?’ stare",goal:"joint",detail:"joint_stairs"}
      ];
    }
    return [
      {id:"skin_shedding",icon:"🧹",label:"Fur tumbleweeds everywhere",goal:"skin",detail:"skin_shedding"},
      {id:"skin_dull",icon:"🌫️",label:"The shine went missing",goal:"skin",detail:"skin_shedding"},
      {id:"skin_flaky",icon:"❄️",label:"Flakes showed up uninvited",goal:"skin",detail:"skin_flaky"},
      {id:"skin_brittle",icon:"✨",label:"Fur feels rough and blah",goal:"skin",detail:"skin_flaky"}
    ];
  }
  function applySignal(option){
    resetSignalAnswers();
    answers.signal=option.id;
    answers.goal=option.goal;
    answers.details=[option.detail];
    if(option.goal==="allergy") answers.allergy=[option.detail==="itch_ears"?"head_shaking":"scratching"];
    if(option.goal==="joint") answers.mobility=[option.detail==="joint_stairs"?"flexibility":"stiffness"];
    if(option.goal==="skin") answers.allergy=["thin_dull"];
  }
  function renderSignal(){
    var options=signalOptions();
    var title=entryGoal?("Which little clue is "+escapeHtml(answers.dogName||"your pup")+" leaving everywhere?"):"What’s stealing "+escapeHtml(answers.dogName||"your pup")+"’s sparkle?";
    var copy=entryGoal?"Pick the one that makes you say, ‘Yep, that’s my dog.’":"Pick the biggest dog-mom ‘ugh’ first. We’ll match one clear jar.";
    stage.innerHTML='<section class="pp-screen pp-question">'+questionHeader(3,"age")+'<h2>'+title+'</h2><p class="pp-sub">'+copy+'</p><div class="pp-choices">'+options.map(function(option){var on=answers.signal===option.id;return '<button type="button" class="pp-choice'+(on?" is-selected":"")+'" data-signal="'+escapeAttribute(option.id)+'"><span><span aria-hidden="true">'+option.icon+'</span> '+escapeHtml(option.label)+'</span><span class="pp-choice-check">'+(on?"✓":"")+'</span></button>';}).join("")+'</div><button class="pp-btn pp-next" type="button" data-next'+(answers.signal?"":" disabled")+'>Aha—keep going →</button></section>';
    stage.querySelectorAll("[data-signal]").forEach(function(button){button.addEventListener("click",function(){var id=button.getAttribute("data-signal");var option=options.filter(function(item){return item.id===id;})[0];if(!option)return;applySignal(option);emit("quiz_answer",{step:3,step_id:"signal",answer_value:id,matched_goal:answers.goal});renderSignal();bindSharedEvents();});});
    var next=stage.querySelector("[data-next]");if(next)next.addEventListener("click",function(){if(answers.signal)setScreen("transition1");});
  }

  function patternOptions(){
    if(answers.goal==="joint") return [
      ["after_rest","Mostly after naps","The rusty-start shuffle"],
      ["stairs","Mostly on stairs","Each step gets a side-eye"],
      ["after_play","After walks or play","Fun now, slow later"],
      ["often","Most of the day","The hesitation keeps showing up"]
    ];
    if(answers.goal==="skin") return [
      ["seasonal","Certain seasons","The fluff storm has a calendar"],
      ["after_baths","After baths or grooming","Spa day, then blah fur"],
      ["steady","Pretty much always","The vacuum knows the drill"],
      ["new","It just started","A brand-new fur mystery"]
    ];
    return [
      ["outside","After outside time","Grass comes with consequences"],
      ["seasonal","Certain seasons","The itch has a calendar"],
      ["steady","Pretty much always","No off switch in sight"],
      ["meals","Around mealtime","The bowl joins the suspect list"]
    ];
  }
  function renderPattern(){
    var options=patternOptions();
    stage.innerHTML='<section class="pp-screen pp-question">'+questionHeader(4,"transition1")+
      '<h2>When does the drama show up most?</h2><p class="pp-sub">The pattern is a clue. Your dog is basically leaving tiny detective notes.</p><div class="pp-choices">'+
      options.map(function(option){var on=answers.pattern===option[0];return '<button type="button" class="pp-choice'+(on?" is-selected":"")+'" data-pattern="'+option[0]+'"><span><b>'+option[1]+'</b><small>'+option[2]+'</small></span><span class="pp-choice-check">'+(on?"✓":"")+'</span></button>';}).join("")+
      '</div><button class="pp-btn pp-next" type="button" data-next'+(answers.pattern?"":" disabled")+'>Clue collected →</button></section>';
    stage.querySelectorAll("[data-pattern]").forEach(function(button){button.addEventListener("click",function(){answers.pattern=button.getAttribute("data-pattern");emit("quiz_answer",{step:4,step_id:"pattern",answer_value:answers.pattern});renderPattern();bindSharedEvents();});});
    var next=stage.querySelector("[data-next]");if(next)next.addEventListener("click",function(){if(answers.pattern)setScreen("impact");});
  }

  function impactOptions(){
    if(answers.goal==="joint") return [
      ["getting_up","Getting up","The floor keeps winning"],
      ["stairs","Stairs","Every step needs a pep talk"],
      ["jumping","Couch or car jumps","The launch button went missing"],
      ["play","Walks and play","Adventure mode ends early"]
    ];
    if(answers.goal==="skin") return [
      ["shedding","Fur tumbleweeds","Your leggings are collecting evidence"],
      ["flakes","Flakes","Unexpected snow, indoors"],
      ["texture","Rough-feeling fur","Cuddles deserve softer"],
      ["shine","Missing shine","The glow-up needs a comeback"]
    ];
    return [
      ["paws","Paw licking","Those paws are not snacks"],
      ["ears","Head shaking","The ears keep starting a remix"],
      ["sleep","Settling down","The itch interrupts cuddle time"],
      ["outside","Walks and play","Outside fun comes with scratching"]
    ];
  }
  function renderImpact(){
    var options=impactOptions();
    stage.innerHTML='<section class="pp-screen pp-question">'+questionHeader(5,"pattern")+
      '<h2>What’s the biggest everyday “ugh”?</h2><p class="pp-sub">Pick the moment you most want back for '+escapeHtml(answers.dogName||"your pup")+'.</p><div class="pp-choices">'+
      options.map(function(option){var on=answers.impact===option[0];return '<button type="button" class="pp-choice'+(on?" is-selected":"")+'" data-impact="'+option[0]+'"><span><b>'+option[1]+'</b><small>'+option[2]+'</small></span><span class="pp-choice-check">'+(on?"✓":"")+'</span></button>';}).join("")+
      '</div><button class="pp-btn pp-next" type="button" data-next'+(answers.impact?"":" disabled")+'>Yep, that one →</button></section>';
    stage.querySelectorAll("[data-impact]").forEach(function(button){button.addEventListener("click",function(){answers.impact=button.getAttribute("data-impact");emit("quiz_answer",{step:5,step_id:"impact",answer_value:answers.impact});renderImpact();bindSharedEvents();});});
    var next=stage.querySelector("[data-next]");if(next)next.addEventListener("click",function(){if(answers.impact)setScreen("approach");});
  }

  function approachLabel(value){
    var labels={nothing:"Nothing yet",topical:"The bathroom experiment",diet:"The bowl remix",supplement:"Another chew"};
    return labels[value]||"Not selected";
  }
  
  function renderApproach(){
    var options=[
      ["nothing","Nothing yet","Fresh mystery"],
      ["topical","Shampoo or spray","The bathroom experiment"],
      ["diet","Food change","The bowl remix"],
      ["supplement","Another chew","Been there, chewed that"]
    ];
    stage.innerHTML='<section class="pp-screen pp-question">'+questionHeader(6,"impact")+'<h2>What has dog-mom detective mode tried already?</h2><p class="pp-sub">No judgment. We’re skipping the stuff that already flopped.</p><div class="pp-choices">'+options.map(function(option){var on=answers.approach===option[0];return '<button type="button" class="pp-choice'+(on?" is-selected":"")+'" data-approach="'+option[0]+'"><span><b>'+escapeHtml(option[1])+'</b><small>'+escapeHtml(option[2])+'</small></span><span class="pp-choice-check">'+(on?"✓":"")+'</span></button>';}).join("")+'</div><button class="pp-btn pp-next" type="button" data-next'+(answers.approach?"":" disabled")+'>Aha—keep going →</button></section>';
    stage.querySelectorAll("[data-approach]").forEach(function(button){button.addEventListener("click",function(){answers.approach=button.getAttribute("data-approach");emit("quiz_answer",{step:6,step_id:"approach",answer_value:answers.approach});renderApproach();bindSharedEvents();});});
    var next=stage.querySelector("[data-next]");if(next)next.addEventListener("click",function(){if(answers.approach)setScreen("transition2");});
  }
  function renderWeight(){
    var bands=[
      {id:"small",label:"Small",range:"1–25 lb",weight:20,icon:"🐕"},
      {id:"medium",label:"Medium",range:"26–50 lb",weight:35,icon:"🐕"},
      {id:"large",label:"Large",range:"51+ lb",weight:75,icon:"🐕"}
    ];
    stage.innerHTML='<section class="pp-screen pp-question">'+questionHeader(7,"transition2")+'<h2>How big is '+escapeHtml(answers.dogName||"your bestie")+'?</h2><p class="pp-sub">Tiny floof and gentle giant do not share a chew count. Size tells us how many chews go in the daily snack attack.</p><div class="pp-choices pp-goals">'+bands.map(function(band){var on=answers.weightBand===band.id;return '<button type="button" class="pp-choice'+(on?" is-selected":"")+'" data-weight-band="'+band.id+'"><span><span aria-hidden="true">'+band.icon+'</span> <b>'+band.label+'</b><small>'+band.range+'</small></span><span class="pp-choice-check">'+(on?"✓":"")+'</span></button>';}).join("")+'</div><div class="pp-field-wrap"><label class="pp-label" for="pp-exact-weight">Exact weight (optional)</label><input class="pp-field" id="pp-exact-weight" type="number" inputmode="decimal" min="1" max="250" step=".1" value="'+escapeAttribute(answers.exactWeight||"")+'"><div class="pp-inline-error" id="pp-weight-error">Enter 1–250 lb.</div></div><button class="pp-btn pp-next" type="button" data-next'+(answers.weightBand?"":" disabled")+'>One last tap →</button></section>';
    stage.querySelectorAll("[data-weight-band]").forEach(function(button){button.addEventListener("click",function(){var id=button.getAttribute("data-weight-band");var band=bands.filter(function(item){return item.id===id;})[0];answers.weightBand=id;answers.weight=band.weight;answers.exactWeight="";emit("quiz_answer",{step:7,step_id:"weight",weight_band:id});renderWeight();bindSharedEvents();});});
    var exact=stage.querySelector("#pp-exact-weight");
    var next=stage.querySelector("[data-next]");
    if(next)next.addEventListener("click",function(){var entered=exact.value.trim();if(entered){var value=Number(entered);if(!refillForWeight(value)){stage.querySelector("#pp-weight-error").classList.add("is-visible");return;}answers.weight=Math.round(value*10)/10;answers.exactWeight=String(answers.weight);answers.weightBand=value<=25?"small":value<=50?"medium":"large";}if(!answers.weightBand||!refillForWeight(answers.weight))return;emit("quiz_answer",{step:7,step_id:"weight",weight_band:answers.weightBand,exact_weight:entered?answers.weight:null});setScreen("email");});
  }

  var quizEmailRequest = null;
  function captureQuizEmail(email){
    if(internalQaInfo && internalQaInfo.value) return Promise.resolve();
    if(!answers.emailConsent) return Promise.reject(new Error("Consent is required"));
    if(quizEmailRequest) return quizEmailRequest;
    var recommendation = currentRecommendation();
    var primary = recommendation.primaryKey ? PRODUCTS[recommendation.primaryKey] : null;
    var properties = {
      "Dog Name": answers.dogName,
      "Dog Age": answers.age,
      "Quiz Goal": answers.goal,
      "Quiz Signal": answers.signal,
      "Quiz Pattern": answers.pattern,
      "Quiz Impact": answers.impact,
      "Quiz Recommendation": primary ? primary.name : "Compare PuzzlePup products",
      "Marketing Consent": true
    };
    var eventData = Object.assign({}, recommendationEventData(), properties);
    quizEmailRequest = fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + encodeURIComponent(CONFIG.klaviyoPublicKey), {
      method: "POST",
      headers: {"Content-Type":"application/vnd.api+json", "revision":"2026-07-15"},
      body: JSON.stringify({data:{
        type:"subscription",
        attributes:{custom_source:"PuzzlePup Dog Match Quiz - checked email consent",profile:{data:{type:"profile",attributes:{
          email:email,
          properties:properties,
          subscriptions:{email:{marketing:{consent:"SUBSCRIBED"}}}
        }}}},
        relationships:{list:{data:{type:"list",id:CONFIG.klaviyoListId}}}
      }})
    }).then(function(response){
      if(!response.ok) throw new Error("Email signup was not accepted");
      // Identification/tracking alone does not create email marketing consent.
      // Record the existing flow event only after Klaviyo accepts the signup.
      window._learnq = window._learnq || [];
      window._learnq.push(["identify", Object.assign({"$email":email},properties)]);
      window._learnq.push(["track", CONFIG.klaviyoEvent, eventData]);
    });
    quizEmailRequest = quizEmailRequest.then(function(value){quizEmailRequest=null;return value;},function(error){quizEmailRequest=null;throw error;});
    return quizEmailRequest;
  }

  function submitQuizEmail(field, consent, submit, errorElement){
    var email = field.value.trim();
    if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) || (consent && !consent.checked)) return;
    if(submit.getAttribute("aria-busy") === "true") return;
    answers.email=email; answers.emailConsent=true;
    submit.disabled=true; submit.setAttribute("aria-busy","true");
    submit.textContent="Saving your email…";
    errorElement.classList.remove("is-visible");
    errorElement.setAttribute("role","alert");
    return captureQuizEmail(email).then(function(){
      answers.emailStatus="submitted";
      emit("quiz_answer",{step:8,step_id:"email",answer_value:"submitted"});
      setScreen("result");
    }).catch(function(){
      answers.emailStatus="failed";
      errorElement.textContent="We couldn’t save your email. Try again, or skip to see your match.";
      errorElement.classList.add("is-visible");
      submit.disabled=false; submit.removeAttribute("aria-busy");
      submit.textContent="Try again";
    });
  }

  function renderEmail(){
    stage.innerHTML='<section class="pp-screen pp-question">'+questionHeader(8,"weight")+
      '<span class="pp-eyebrow">The optional dog-mom tap</span><h2>Want '+escapeHtml(answers.dogName||"your pup")+'’s match in your inbox?</h2>'+
      '<p class="pp-sub">Add your email for the match and occasional PuzzlePup notes—or skip it and see the answer now. No email wall.</p>'+
      '<div class="pp-field-wrap"><label class="pp-label" for="pp-quiz-email">Email (optional)</label><input class="pp-field" id="pp-quiz-email" type="email" inputmode="email" autocomplete="email" value="'+escapeAttribute(answers.email||"")+'"><div class="pp-inline-error" id="pp-email-error">That email looks a little ruff. Check it and try again.</div></div>'+
      '<button class="pp-btn pp-next" type="button" data-email-result>Email my match + show it →</button>'+
      '<button class="pp-link-button pp-retake" type="button" data-email-skip>Skip—show my match</button>'+
      '<p class="pp-fine">By emailing the match, you agree to receive PuzzlePup emails. Unsubscribe anytime.</p></section>';
    var field=stage.querySelector("#pp-quiz-email");
    stage.querySelector("[data-email-result]").addEventListener("click",function(){
      submitQuizEmail(field,null,stage.querySelector("[data-email-result]"),stage.querySelector("#pp-email-error"));
    });;
    stage.querySelector("[data-email-skip]").addEventListener("click",function(){
      answers.email="";answers.emailStatus="skipped";answers.emailConsent=false;
      emit("quiz_answer",{step:8,step_id:"email",answer_value:"skipped"});setScreen("result");
    });
  }

  function firstQuestionHeaderV36(){
    return '<div class="pp-topline pp-topline-first"><span class="pp-step-count">Question 1 of 8</span></div>'+
      '<div class="pp-progress" role="progressbar" aria-valuemin="1" aria-valuemax="8" aria-valuenow="1" aria-label="Question 1 of 8"><span style="width:12.5%"></span></div>';
  }

  function renderIntroV36(){
    var targeted=entryGoal?GOALS[entryGoal]:GOALS.wellness;
    var productKey=entryGoal==="allergy"?"A":entryGoal==="joint"?"J":entryGoal==="skin"?"S":null;
    stage.innerHTML='<section class="pp-screen pp-intro-screen" data-pp-layout-guard>'+firstQuestionHeaderV36()+
      '<div class="pp-intro-media" data-pp-media>'+introProductsMarkup(productKey)+'</div>'+
      '<div class="pp-intro-content" data-pp-copy><h1>Find daily chews for <em>your dog</em></h1><p class="pp-sub">Answer eight quick questions to see which chews may fit your dog. No email needed to see your match.</p>'+ 
      '<div class="pp-intro-form"><h2>What’s your dog’s name?</h2><div class="pp-field-wrap"><label class="pp-label" for="pp-dog-name-v36">Dog’s name</label><input class="pp-field" id="pp-dog-name-v36" type="text" maxlength="15" autocomplete="off" value="'+escapeAttribute(answers.dogName)+'"><small>Max 15 characters</small></div>'+ 
      '<button class="pp-btn pp-next" type="button" data-name-next'+(answers.dogName?'':' disabled')+'>Continue</button></div></div></section>';
    var field=stage.querySelector("#pp-dog-name-v36");
    var next=stage.querySelector("[data-name-next]");
    field.addEventListener("input",function(){next.disabled=!field.value.trim();});
    next.addEventListener("click",function(){var value=field.value.trim();if(!value)return;answers.dogName=value;emit("quiz_start",{start_path:entryGoal?"targeted":"general",preselected_goal:entryGoal||null});emit("quiz_answer",{step:1,step_id:"name"});setScreen("profile");});
  }

  function renderProfileV36(){
    var unknown=answers.breed==="I don’t know";
    stage.innerHTML='<section class="pp-screen pp-question pp-question-narrow">'+questionHeader(2,"intro")+
      '<h2>What breed is '+escapeHtml(answers.dogName||"your pup")+'?</h2>'+ 
      '<div class="pp-field-wrap"><label class="pp-label" for="pp-breed-v36">What is your dog’s breed?</label><input class="pp-field" id="pp-breed-v36" type="text" maxlength="60" autocomplete="off" value="'+escapeAttribute(unknown?'':answers.breed)+'"'+(unknown?' disabled':'')+'></div>'+ 
      '<div class="pp-or">OR</div>'+ 
      '<button class="pp-choice pp-inline-choice'+(unknown?' is-selected':'')+'" type="button" data-breed-unknown><span>I don’t know their breed</span><span class="pp-choice-check">'+(unknown?'✓':'')+'</span></button>'+ 
      '<h2 class="pp-second-question">What gender is '+escapeHtml(answers.dogName||"your pup")+'?</h2><div class="pp-choices pp-goals pp-two-up">'+
      [['male','Male'],['female','Female']].map(function(option){var on=answers.gender===option[0];return '<button type="button" class="pp-choice'+(on?' is-selected':'')+'" data-gender="'+option[0]+'"><span><b>'+option[1]+'</b></span><span class="pp-choice-check">'+(on?'✓':'')+'</span></button>';}).join('')+
      '</div><button class="pp-btn pp-next" type="button" data-profile-next'+(answers.breed&&answers.gender?'':' disabled')+'>Continue</button></section>';
    var breed=stage.querySelector("#pp-breed-v36");
    var next=stage.querySelector("[data-profile-next]");
    function sync(){if(!breed.disabled)answers.breed=breed.value.trim();next.disabled=!(answers.breed&&answers.gender);}
    breed.addEventListener("input",sync);
    stage.querySelector("[data-breed-unknown]").addEventListener("click",function(){answers.breed=unknown?'':"I don’t know";renderProfileV36();bindSharedEvents();});
    stage.querySelectorAll("[data-gender]").forEach(function(button){button.addEventListener("click",function(){answers.gender=button.getAttribute("data-gender");if(!breed.disabled)answers.breed=breed.value.trim();renderProfileV36();bindSharedEvents();});});
    next.addEventListener("click",function(){sync();if(!answers.breed||!answers.gender)return;emit("quiz_answer",{step:2,step_id:"breed_gender",breed_known:answers.breed!=="I don’t know",gender:answers.gender});setScreen("ageweight");});
  }

  function ageSummaryV36(){
    if(answers.ageUnknown)return "Unknown";
    var years=Math.max(0,Number(answers.ageYears)||0);
    var months=Math.max(0,Number(answers.ageMonths)||0);
    if(years&&months)return years+" yr "+months+" mo";
    if(years)return years+" year"+(years===1?'':'s');
    if(months)return months+" month"+(months===1?'':'s');
    return "Age not entered";
  }

  function weightSummaryV36(){
    if(answers.exactWeight)return answers.exactWeight+" lb";
    if(answers.weightBand==="extra_small")return "Under 12 lb";
    if(answers.weightBand==="small")return "12–24.9 lb";
    if(answers.weightBand==="medium")return "25–50 lb";
    if(answers.weightBand==="large")return "Over 50 lb";
    return "Size not entered";
  }

  function dogSizeIconV36(size){
    var scale=size==="xs"?.58:size==="sm"?.72:size==="md"?.88:1;
    return '<span class="pp-dog-size pp-dog-size-'+size+'" aria-hidden="true"><svg viewBox="0 0 74 58" focusable="false" style="transform:scale('+scale+')"><path d="M18 23c-4-9-2-17 4-21 2 8 7 12 13 13 6-4 13-6 21-5 5 1 9 4 11 8 3 6 2 15-3 20l4 13h-8l-4-10H34l-3 10h-8l3-14c-5-3-8-8-8-14Zm42-8c4-5 8-6 12-4-3 6-6 9-11 10M18 25 8 30l-6-5 8-2 4-7" fill="currentColor"/><circle cx="55" cy="18" r="2" fill="#fff"/></svg></span>';
  }

  function renderAgeWeightV36(){
    var bands=[
      {id:"extra_small",label:"Extra Small Dog",range:"Under 12 lb",weight:10,size:"xs"},
      {id:"small",label:"Small Dog",range:"12–24.9 lb",weight:20,size:"sm"},
      {id:"medium",label:"Medium Dog",range:"25–50 lb",weight:45,size:"md"},
      {id:"large",label:"Large Dog",range:"Over 50 lb",weight:90,size:"lg"}
    ];
    stage.innerHTML='<section class="pp-screen pp-question pp-question-narrow">'+questionHeader(3,"profile")+
      '<h2>How old is '+escapeHtml(answers.dogName||"your bestie")+'?</h2><p class="pp-age-help">Don’t know the exact date? A best guess is okay.</p>'+ 
      '<div class="pp-age-fields"><div class="pp-field-wrap"><label class="pp-label" for="pp-age-years-v36">Years</label><input class="pp-field" id="pp-age-years-v36" type="number" inputmode="numeric" min="0" max="30" step="1" value="'+escapeAttribute(answers.ageYears)+'"></div><div class="pp-field-wrap"><label class="pp-label" for="pp-age-months-v36">Months</label><input class="pp-field" id="pp-age-months-v36" type="number" inputmode="numeric" min="0" max="11" step="1" value="'+escapeAttribute(answers.ageMonths)+'"></div></div>'+ 
      '<div class="pp-or">OR</div><button class="pp-choice pp-inline-choice'+(answers.ageUnknown?' is-selected':'')+'" type="button" data-age-unknown><span>I don’t know '+escapeHtml(answers.dogName||"my dog")+'’s age</span><span class="pp-choice-check">'+(answers.ageUnknown?'✓':'')+'</span></button>'+ 
      '<h2 class="pp-second-question">How much does '+escapeHtml(answers.dogName||"your bestie")+' weigh?</h2><div class="pp-choices pp-goals pp-size-grid">'+bands.map(function(band){var on=answers.weightBand===band.id;return '<button type="button" class="pp-choice pp-size-choice'+(on?' is-selected':'')+'" data-weight-band-v36="'+band.id+'">'+dogSizeIconV36(band.size)+'<span><b>'+band.label+'</b><small>'+band.range+'</small></span><span class="pp-choice-check">'+(on?'✓':'')+'</span></button>';}).join('')+'</div>'+ 
      '<div class="pp-or">OR</div><button class="pp-choice pp-inline-choice'+(answers.showExactWeight?' is-selected':'')+'" type="button" data-show-exact-weight><span>I know '+escapeHtml(answers.dogName||"my dog")+'’s exact weight</span><span class="pp-choice-check">'+(answers.showExactWeight?'✓':'')+'</span></button>'+ 
      '<div class="pp-field-wrap pp-exact-weight"'+(answers.showExactWeight?'':' hidden')+'><label class="pp-label" for="pp-exact-weight-v36">Exact weight in pounds</label><input class="pp-field" id="pp-exact-weight-v36" type="number" inputmode="decimal" min="1" max="250" step=".1" value="'+escapeAttribute(answers.exactWeight)+'"></div><div class="pp-inline-error" id="pp-age-weight-error">Add an age and choose a size from 1–250 lb.</div>'+ 
      '<button class="pp-btn pp-next" type="button" data-age-weight-next'+(((answers.ageUnknown||answers.ageYears||answers.ageMonths)&&answers.weightBand)?'':' disabled')+'>Continue</button></section>';
    var years=stage.querySelector("#pp-age-years-v36");
    var months=stage.querySelector("#pp-age-months-v36");
    var exact=stage.querySelector("#pp-exact-weight-v36");
    var next=stage.querySelector("[data-age-weight-next]");
    function sync(){answers.ageYears=years.value.trim();answers.ageMonths=months.value.trim();if(answers.ageYears||answers.ageMonths)answers.ageUnknown=false;answers.exactWeight=exact?exact.value.trim():"";if(answers.exactWeight){var exactNumber=Number(answers.exactWeight);if(refillForWeight(exactNumber)){answers.weight=Math.round(exactNumber*10)/10;answers.weightBand=exactNumber<12?"extra_small":exactNumber<25?"small":exactNumber<=50?"medium":"large";}}next.disabled=!((answers.ageUnknown||answers.ageYears||answers.ageMonths)&&answers.weightBand);}
    years.addEventListener("input",sync);months.addEventListener("input",sync);exact.addEventListener("input",sync);
    stage.querySelectorAll("[data-weight-band-v36]").forEach(function(button){button.addEventListener("click",function(){sync();var id=button.getAttribute("data-weight-band-v36");var band=bands.filter(function(item){return item.id===id;})[0];answers.weightBand=id;answers.weight=band.weight;answers.exactWeight="";renderAgeWeightV36();bindSharedEvents();});});
    stage.querySelector("[data-age-unknown]").addEventListener("click",function(){answers.ageUnknown=!answers.ageUnknown;if(answers.ageUnknown){answers.ageYears="";answers.ageMonths="";}renderAgeWeightV36();bindSharedEvents();});
    stage.querySelector("[data-show-exact-weight]").addEventListener("click",function(){answers.showExactWeight=!answers.showExactWeight;if(!answers.showExactWeight)answers.exactWeight="";renderAgeWeightV36();bindSharedEvents();});
    next.addEventListener("click",function(){sync();var y=Number(answers.ageYears||0);var m=Number(answers.ageMonths||0);if((!answers.ageUnknown&&(y<0||y>30||m<0||m>11||(!y&&!m)))||!refillForWeight(answers.weight)){stage.querySelector("#pp-age-weight-error").classList.add("is-visible");return;}answers.age=answers.ageUnknown?"unknown":y<1?"puppy":y<=3?"young":y<=7?"adult":"senior";emit("quiz_answer",{step:3,step_id:"age_size",age_years:answers.ageUnknown?null:y,age_months:answers.ageUnknown?null:m,weight_band:answers.weightBand,exact_weight:answers.exactWeight||null});setScreen("skin");});
  }

  function renderConcernV36(key){
    var concern=CONCERNS[key];
    var selected=Array.isArray(answers[key])?answers[key]:[];
    stage.innerHTML='<section class="pp-screen pp-question pp-question-narrow">'+questionHeader(concern.step,concern.back)+
      '<span class="pp-concern-label">'+escapeHtml(concern.label)+'</span><h2>'+escapeHtml(concern.title)+'</h2><p class="pp-select-copy">'+escapeHtml(concern.copy)+'</p>'+ 
      '<div class="pp-choices pp-concern-choices">'+concern.options.map(function(option){var on=selected.indexOf(option[0])>=0;return '<button type="button" class="pp-choice'+(on?' is-selected':'')+'" data-concern-choice="'+escapeAttribute(option[0])+'"><span>'+escapeHtml(option[1])+'</span><span class="pp-choice-check">'+(on?'✓':'')+'</span></button>';}).join('')+'</div>'+ 
      '<div class="pp-education-note"><h3>'+escapeHtml(concern.noteTitle)+'</h3><p>'+escapeHtml(concern.note)+'</p></div>'+ 
      '<button class="pp-btn pp-next" type="button" data-concern-next'+(selected.length?'':' disabled')+'>'+(key==='mobility'?'Complete Quiz':'Continue')+'</button></section>';
    stage.querySelectorAll("[data-concern-choice]").forEach(function(button){button.addEventListener("click",function(){var value=button.getAttribute("data-concern-choice");var nextSelected=selected.slice();if(value==="none")nextSelected=nextSelected.indexOf("none")>=0?[]:["none"];else{nextSelected=nextSelected.filter(function(item){return item!=="none";});var index=nextSelected.indexOf(value);if(index>=0)nextSelected.splice(index,1);else nextSelected.push(value);}answers[key]=nextSelected;renderConcernV36(key);bindSharedEvents();});});
    var next=stage.querySelector("[data-concern-next]");
    if(next)next.addEventListener("click",function(){if(!answers[key].length)return;emit("quiz_answer",{step:concern.step,step_id:key+"_concerns",answer_values:answers[key].slice()});setScreen(concern.next);});
  }

  function renderEmailV36(){
    stage.innerHTML='<section class="pp-screen pp-question pp-question-narrow">'+questionHeader(8,"mobility")+
      '<h2>We’re now putting together '+escapeHtml(answers.dogName||"your pup")+'’s recommendations…</h2>'+ 
      '<p class="pp-sub">Want the match in your inbox and the occasional PuzzlePup note?</p>'+ 
      '<div class="pp-field-wrap"><label class="pp-label" for="pp-quiz-email-v36">Email address</label><input class="pp-field" id="pp-quiz-email-v36" type="email" inputmode="email" autocomplete="email" value="'+escapeAttribute(answers.email||'')+'"><div class="pp-inline-error" id="pp-email-error-v36">That email looks a little ruff. Check it and try again.</div></div>'+ 
      '<label class="pp-consent"><input type="checkbox" data-email-consent-v36'+(answers.emailConsent?' checked':'')+'><span>Send me PuzzlePup updates, offers, and dog care tips. Unsubscribe anytime.</span></label>'+ 
      '<button class="pp-btn pp-next" type="button" data-email-result-v36 disabled>Sign Up</button>'+ 
      '<button class="pp-link-button pp-retake" type="button" data-email-skip-v36>No thanks, show me the results</button>'+ 
      '</section>';
    var field=stage.querySelector("#pp-quiz-email-v36");
    var consent=stage.querySelector("[data-email-consent-v36]");
    var submit=stage.querySelector("[data-email-result-v36]");
    function syncEmail(){submit.disabled=!(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(field.value.trim())&&consent.checked);}
    field.addEventListener("input",syncEmail);consent.addEventListener("change",syncEmail);syncEmail();
    stage.querySelector("[data-email-result-v36]").addEventListener("click",function(){submitQuizEmail(field,consent,submit,stage.querySelector("#pp-email-error-v36"));});
    stage.querySelector("[data-email-skip-v36]").addEventListener("click",function(){answers.email="";answers.emailStatus="skipped";answers.emailConsent=false;emit("quiz_answer",{step:8,step_id:"email",answer_value:"skipped"});setScreen("result");});
  }
  
  function activeVisualKey(){
    if(entryGoal==="allergy") return "A";
    if(entryGoal==="joint") return "J";
    if(entryGoal==="skin") return "S";
    var goal=String(answers.goal||"");
    if(goal==="joint") return "J";
    if(goal==="skin") return "S";
    if(goal==="allergy") return "A";
    deriveRecommendationInputs();
    return answers.goal==="joint"?"J":answers.goal==="skin"?"S":"A";
  }

  function renderTransition(step){
    deriveRecommendationInputs();
    var key=activeVisualKey();
    var visual=FUNNEL_IMAGES[key];
    var first=step===1;
    var backScreen=first?"signal":"approach";
    var nextScreen=first?"pattern":"weight";
    var altBase=key==="A"?"Allergy Soft Chews":key==="J"?"Hip and Joint":"Skin and Coat";
    stage.innerHTML='<section class="pp-screen pp-transition-screen"><div class="pp-topline"><button class="pp-back" type="button" data-back="'+backScreen+'">‹ Back</button><span class="pp-step-count">Dog-mom detective mode: on</span></div>'+
      '<img class="pp-transition-image" '+responsiveImageAttributes(visual.transitions[step-1],[343,515,686,1029,1402],"(max-width: 760px) calc(100vw - 40px), 760px")+' alt="'+escapeAttribute(altBase+' chew explanation')+'" width="1402" height="1122" fetchpriority="'+(first?"high":"auto")+'" decoding="async">'+
      '<button class="pp-btn" type="button" data-transition-next>'+(first?"Aha—keep sniffing →":"Now pick the chew count →")+'</button></section>';
    stage.querySelector("[data-transition-next]").addEventListener("click",function(){setScreen(nextScreen);});
  }
  function deriveRecommendationInputs(){
    var recommendation=recommendationForAnswers(answers);
    var key=recommendation.primaryKey||"A";
    answers.goal=key==="A"?"allergy":key==="J"?"joint":"skin";
    if(key==="A")answers.details=["itch_scratching"];
    else if(key==="J")answers.details=["joint_stiffness"];
    else answers.details=["skin_shedding"];
    return recommendation;
  }
  function currentRecommendation() {
    return recommendationForAnswers(answers);
  }

  function recommendationEventData() {
    var recommendation = currentRecommendation();
    var refill = refillForWeight(answers.weight);
    var primary = recommendation.primaryKey
      ? PRODUCTS[recommendation.primaryKey]
      : null;
    return {
      result_type: recommendation.noMatch ? "no_match" : "product_match",
      primary_product_key: recommendation.primaryKey,
      primary_product_name: primary ? primary.name : null,
      primary_variant_id: primary ? primary.variantId : null,
      secondary_product_key: recommendation.secondaryKey,
      vet_first_guidance: false,
      dog_weight_lb: answers.weight || null,
      chews_per_day: refill ? refill.chewsPerDay : null,
      jar_duration_days: refill ? refill.jarDays : null,
      refill_quantity: refill ? refill.quantity : null,
      refill_cadence: refill ? refill.cadence : null,
      selling_plan_id: refill ? refill.sellingPlanId : null,
      email_status: answers.emailStatus,
      dog_age: answers.age || null,
      pattern: answers.pattern || null,
      everyday_impact: answers.impact || null,
    };
  }

  function concernCountV36(key){
    return (Array.isArray(answers[key])?answers[key]:[]).filter(function(value){return value!=="none";}).length;
  }

  function healthReportMarkup(){
    var categories=[
      {key:"skin",label:"Skin & Coat",icon:"✨"},
      {key:"gut",label:"Belly",icon:"🫶"},
      {key:"allergy",label:"Allergy & Itch",icon:"🐾"},
      {key:"mobility",label:"Movement",icon:"🦴"}
    ];
    return '<section class="pp-health-panel"><div class="pp-dose-grid pp-profile-grid" aria-label="'+escapeAttribute((answers.dogName||"Your pup")+' profile')+'">'+
      '<div class="pp-dose-cell"><span>Breed</span><b>'+escapeHtml(answers.breed||"Not known")+'</b></div>'+ 
      '<div class="pp-dose-cell"><span>Size</span><b>'+escapeHtml(weightSummaryV36())+'</b></div>'+ 
      '<div class="pp-dose-cell"><span>Age</span><b>'+escapeHtml(ageSummaryV36())+'</b></div></div>'+ 
      '<p class="pp-health-intro">These are the clues you selected for '+escapeHtml(answers.dogName||"your pup")+'. This shopping guide does not diagnose a health condition.</p>'+ 
      '<div class="pp-health-categories" aria-label="Health clues">'+categories.map(function(category){var count=concernCountV36(category.key);return '<div class="pp-health-category"><span class="pp-health-category-icon '+(count?'has-clue':'is-clear')+'" aria-hidden="true">'+(count?'☹':'☺')+'</span>'+(count?'<span class="pp-health-category-count" aria-label="'+count+' clue'+(count===1?'':'s')+'">'+count+'</span>':'')+'<b>'+escapeHtml(category.label)+'</b></div>';}).join('')+'</div></section>';
  }

  function productVideosMarkupV36(product){
    var videos=PRODUCT_VIDEOS[product.key]||[];
    if(!videos.length)return '';
    return '<section class="pp-quiz-videos" aria-label="Watch '+escapeAttribute(product.name)+'">'+
      '<header class="pp-quiz-videos-header"><span>SEE THE PRODUCT</span><h2>See '+escapeHtml(product.name)+' at bowl time.</h2><p>Two quick peeks. Zero guesswork.</p></header>'+
      '<div class="pp-quiz-videos-grid">'+videos.slice(0,2).map(function(video){return '<figure class="pp-quiz-video"><video controls playsinline preload="metadata" poster="'+escapeAttribute(video.poster)+'" aria-label="'+escapeAttribute(video.caption)+'"><source src="'+escapeAttribute(video.src)+'" type="video/mp4">Your browser cannot play this video.</video><figcaption>'+escapeHtml(video.caption)+'</figcaption></figure>';}).join('')+'</div></section>';
  }

  function bundleGallerySourcesV36(product){
    var sources=FUNNEL_IMAGES[product.key].carousel;
    return ["https://www.puzzlepupco.com/cdn/shop/files/smartmat-original-product.jpg?v=1791148136",sources[0],sources[1],sources[2],sources[3]];
  }

  function recommendationBenefitsV36(product){
    return FORMULAS[product.key].benefits.slice(0,3);
  }

  function recommendationCardMarkupV36(product,role,isBundle){
    var formula=FORMULAS[product.key];
    var sources=isBundle?bundleGallerySourcesV36(product):FUNNEL_IMAGES[product.key].carousel;
    var labels=isBundle?["Premium Snuffle Mat in this pair","Meet the jar","Selected ingredient facts","Read the full label","Serving and storage"]:["Meet the jar","Selected ingredient facts","Read the full label","Serving and storage"];
    var title=isBundle?"PuzzlePup Snuffle Mat + "+product.name:product.name;
    var price=isBundle?4999:CONFIG.oneTimePriceCents;
    var compare=isBundle?(SNUFFLE_MAT.catalogPriceCents+CONFIG.oneTimePriceCents):CONFIG.compareAtPriceCents;
    var benefits=isBundle?["Turn dinner into a sniff-and-search game",formula.benefits[0],"Get the mat and jar together for $49.99"]:recommendationBenefitsV36(product);
    return '<section class="pp-recommendation-card'+(isBundle?' is-bundle':'')+'" aria-label="'+escapeAttribute(title)+'">'+
      visualGalleryMarkup(product,formula,sources,labels,title)+
      '<div class="pp-recommendation-copy">'+(isBundle?'<span class="pp-badge">Optional dinner pair</span>':'')+'<h3>'+escapeHtml(title)+'</h3><p>'+escapeHtml(isBundle?'A daily chew plus a sniff-and-search dinner game in one easy pair.':product.outcome)+'</p>'+ 
      '<ul class="pp-recommendation-benefits">'+benefits.map(function(benefit){return '<li><span aria-hidden="true">✓</span>'+escapeHtml(benefit)+'</li>';}).join('')+'</ul>'+ 
      '<div class="pp-recommendation-price"><b>'+money(price)+'</b>'+compareAtMarkup(price,compare)+'</div>'+ 
      '<button class="pp-btn pp-choose-package" type="button" data-choose-package="'+(isBundle?'bundle':product.key)+'" data-product-role="'+escapeAttribute(role)+'">Choose package</button>'+ 
      (isBundle?'':'<a class="pp-learn-more" data-product-link data-product-role="'+escapeAttribute(role)+'" data-product-key="'+product.key+'" href="'+escapeAttribute(product.url)+'">Learn more →</a>')+'</div></section>';
  }

  function orderedSupplementPicksV36(recommendation){
    var keys=[recommendation.primaryKey,recommendation.secondaryKey,"A","J","S"];
    var seen={};
    return keys.filter(function(key){
      if(!PRODUCTS[key]||seen[key])return false;
      seen[key]=true;
      return true;
    }).slice(0,3).map(function(key){return PRODUCTS[key];});
  }

  function renderResult() {
    var recommendation = deriveRecommendationInputs();
    if(!selectedPlan)selectedPlan="onetime";
    var recommendedProduct=PRODUCTS[recommendation.primaryKey];
    var product=PRODUCTS[selectedResultProductKey]||recommendedProduct;
    var purchaseRecommendation=Object.assign({},recommendation,{primaryKey:product.key,secondaryKey:product.key===recommendation.primaryKey?recommendation.secondaryKey:recommendation.primaryKey});
    var refill = refillForWeight(answers.weight);
    var formula = FORMULAS[product.key];
    var proof = PROOF[product.key];
    var supplementPicks=orderedSupplementPicksV36(recommendation);
    var purchaseAllowed = canOfferPurchase(purchaseRecommendation);

    stage.innerHTML =
      '<section class="pp-screen pp-result-screen">' +
      '<div class="pp-center"><h1>' + escapeHtml(answers.dogName || "Your dog") + '’s product matches</h1>' +
      healthReportMarkup() +
      '</div>'+'<section class="pp-recommendations" aria-label="Our recommendations"><div class="pp-recommendations-intro"><h2>Here’s a match for your dog</h2><p>Start with one jar, or add a Mat for a sniffing game. You choose whether to order once or subscribe.</p></div>'+ 
      recommendationCardMarkupV36(recommendedProduct,"primary",false)+
      '<div class="pp-bundle-intro">Want to add a sniffing game? The premium Mat and this jar are $49.99 together.</div>'+ 
      recommendationCardMarkupV36(recommendedProduct,"bundle",true)+
      '<div class="pp-single-intro">See the other chews</div>'+ 
      supplementPicks.slice(1).map(function(item,index){return recommendationCardMarkupV36(item,index===0?"secondary":"third",false);}).join('')+
      '</section>'+productVideosMarkupV36(recommendedProduct)+ 
      (selectedPackageOpen?'<div class="pp-offer-grid">'+purchaseMarkup(product,refill,purchaseRecommendation)+'</div>':'')+ 
      '<button class="pp-link-button pp-retake" type="button" data-retake>Retake the quiz</button>' +
      "</section>";

    if (purchaseAllowed&&selectedPackageOpen) bindPurchaseEvents(product, refill, purchaseRecommendation);
    stage.querySelectorAll('[data-visual-gallery]').forEach(function(gallery){ bindVisualGallery(product, gallery); });
    stage.querySelectorAll('[data-choose-package]').forEach(function(button){button.addEventListener('click',function(){var choice=button.getAttribute('data-choose-package');selectedPackageOpen=true;if(choice==='bundle'){selectedResultProductKey=recommendation.primaryKey;selectedJarQuantity=1;selectedPlan='onetime';selectedAddons={campaignJar:false,snuffleMat:true};}else{selectedResultProductKey=choice;selectedJarQuantity=1;selectedPlan='onetime';selectedAddons={campaignJar:false,snuffleMat:false};}renderResult();bindSharedEvents();try{stage.querySelector('#pp-purchase').scrollIntoView({behavior:'smooth',block:'start'});}catch(error){}});});
    bindRetake();
  }

  function visualGalleryMarkup(product, formula, customSources, customLabels, galleryLabel) {
    var sources = customSources || FUNNEL_IMAGES[product.key].carousel;
    var labels = customLabels || ["Meet the jar","Selected ingredient facts","Read the full label","Serving and storage"];
    return (
      '<section class="pp-gallery" data-visual-gallery data-gallery-product-key="'+product.key+'" aria-label="'+escapeAttribute(galleryLabel||("Pictures that explain "+product.name))+'">' +
      '<div class="pp-gallery-track" data-gallery-track tabindex="0">' +
      sources.map(function (src, index) {
        return '<figure class="pp-gallery-slide" data-gallery-slide data-gallery-index="' +
          index + '"><button class="pp-gallery-image-button" type="button" data-gallery-image-next aria-label="Show the next image"><img ' + responsiveImageAttributes(src,[300,450,600,750,960,1254],"(max-width: 900px) calc(100vw - 40px), 660px") +
          ' width="1254" height="1254" loading="'+(index===0?'eager':'lazy')+'" decoding="async" alt="' + escapeAttribute(product.name + ": " + labels[index]) +
          '"></button><span class="pp-visually-hidden">'+escapeHtml(labels[index])+'</span></figure>';
      }).join("") +
      '</div><div class="pp-gallery-controls"><button class="pp-gallery-arrow" type="button" data-gallery-prev aria-label="Previous gallery image">‹</button>' +
      '<div class="pp-gallery-dots" role="group" aria-label="Choose a gallery image">' +
      sources.map(function (_, index) {
        return '<button class="pp-gallery-dot' + (index === 0 ? " is-active" : "") +
          '" type="button" data-gallery-dot="' + index + '" aria-label="Go to image ' +
          (index + 1) + ' of ' + sources.length + '" aria-current="' + (index === 0 ? "true" : "false") + '"></button>';
      }).join("") +
      '</div><button class="pp-gallery-arrow" type="button" data-gallery-next aria-label="Next gallery image">›</button></div>' +
      '<div class="pp-visually-hidden">' + escapeHtml(product.outcome + " " + formula.amountBasis) + '</div></section>'
    );
  }

  function qualityProofMarkup(product, formula, refill, proof) {
    return (
      '<section class="pp-proof-grid" aria-label="Why this chew fits your pup"><div class="pp-quality-panel"><h3>Why this jar earns counter space</h3>' +
      '<p>' +
      escapeHtml(formula.systemCopy) +
      '</p><div class="pp-quality-grid">' +
      '<div class="pp-quality"><span aria-hidden="true">🩺</span> Weight-based label directions</div>' +
      '<div class="pp-quality"><span aria-hidden="true">🇺🇸</span> Approximately 60 soft chews</div>' +
      '<div class="pp-quality"><span aria-hidden="true">✓</span> Read the complete product label</div>' +
      '<div class="pp-quality"><span aria-hidden="true">🔎</span> Formula facts are printed on the jar</div>' +
      '</div><div class="pp-action-callout">' +
      refill.servingLabel +
      " chew" +
      (refill.chewsPerDay === 1 ? "" : "s") +
      " daily · " +
      escapeHtml(refill.summary) +
      "</div></div>" +
      proofMarkup(proof, product.key) +
      "</section>"
    );
  }

  function bindVisualGallery(product, gallery) {
    gallery = gallery || stage.querySelector("[data-visual-gallery]");
    if (!gallery) return;
    var track = gallery.querySelector("[data-gallery-track]");
    var slides = Array.prototype.slice.call(
      gallery.querySelectorAll("[data-gallery-slide]"),
    );
    var dots = Array.prototype.slice.call(
      gallery.querySelectorAll("[data-gallery-dot]"),
    );
    var counter=gallery.querySelector("[data-gallery-counter]");
    var galleryProductKey=gallery.getAttribute("data-gallery-product-key")||product.key;
    var previousButton=gallery.querySelector("[data-gallery-prev]");
    var nextButton=gallery.querySelector("[data-gallery-next]");
    var index = 0;
    var frameRequested = false;
    var setActive = function (nextIndex, source) {
      index = Math.max(0, Math.min(slides.length - 1, nextIndex));
      dots.forEach(function (dot, dotIndex) {
        var active = dotIndex === index;
        dot.classList.toggle("is-active", active);
        dot.setAttribute("aria-current", active ? "true" : "false");
      });
      if(counter)counter.textContent=(index+1)+" of "+slides.length;
      if(previousButton)previousButton.hidden=index===0;
      if(nextButton)nextButton.hidden=index===slides.length-1;
      if (source) {
        emit("quiz_gallery_view", {
          product_key: galleryProductKey,
          image_number: index + 1,
          image_count: slides.length,
          interaction_source: source,
        });
      }
    };
    var goTo = function (nextIndex, source) {
      if(!slides.length)return;
      var bounded = ((nextIndex % slides.length) + slides.length) % slides.length;
      var reduced =
        window.matchMedia &&
        window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      try {
        track.scrollTo({
          left: bounded * track.clientWidth,
          behavior: reduced ? "auto" : "smooth",
        });
      } catch (error) {
        track.scrollLeft = bounded * track.clientWidth;
      }
      setActive(bounded, source);
    };
    dots.forEach(function (dot) {
      dot.addEventListener("click", function () {
        goTo(Number(dot.getAttribute("data-gallery-dot")), "dot");
      });
    });
    previousButton.addEventListener("click", function () {
        goTo(index - 1, "previous");
      });
    nextButton.addEventListener("click", function () {
        goTo(index + 1, "next");
      });
    gallery.querySelectorAll("[data-gallery-image-next]").forEach(function(button){button.addEventListener("click",function(){goTo(index+1,"image");});});
    track.addEventListener("scroll", function () {
      if (frameRequested) return;
      frameRequested = true;
      window.requestAnimationFrame(function () {
        frameRequested = false;
        var nextIndex = track.clientWidth
          ? Math.round(track.scrollLeft / track.clientWidth)
          : 0;
        if (nextIndex !== index) setActive(nextIndex, "swipe");
      });
    });
    setActive(0);
  }

  function canOfferPurchase(recommendation) {
    return !recommendation.noMatch;
  }

  function bindResultPurchaseCtas(product) {
    stage.querySelectorAll("[data-purchase-jump]").forEach(function (link) {
      link.addEventListener("click", function () {
        emit("quiz_purchase_jump", {
          product_key: product.key,
          placement: link.hasAttribute("data-sticky-result-cta")
            ? "mobile_sticky"
            : "result_hero",
        });
      });
    });
    var sticky = stage.querySelector("[data-sticky-result-cta]");
    var purchase = stage.querySelector("#pp-purchase");
    if (!sticky || !purchase || !("IntersectionObserver" in window)) return;
    var observer = new IntersectionObserver(
      function (entries) {
        sticky.classList.toggle("is-hidden", Boolean(entries[0].isIntersecting));
      },
      { threshold: 0.05 },
    );
    observer.observe(purchase);
  }

  function doseGridMarkup(refill) {
    var jarCopy =
      refill.quantity === 1
        ? durationLabel(refill,1)
        : durationLabel(refill,1) + " each";
    return (
      '<div class="pp-dose-grid" aria-label="Your dog’s daily chew count">' +
      '<div class="pp-dose-cell"><b>' +
      refill.servingLabel +
      " chew" +
      (refill.chewsPerDay === 1 ? "" : "s") +
      "</b><span>each day</span></div>" +
      '<div class="pp-dose-cell"><b>' +
      escapeHtml(jarCopy) +
      "</b><span>per 60-chew jar</span></div>" +
      '<div class="pp-dose-cell"><b>' +
      refill.quantity +
      " jar" +
      (refill.quantity === 1 ? "" : "s") +
      "</b><span>" +
      escapeHtml(refill.cadence) +
      "</span></div></div>"
    );
  }

  function passiveSafetyMarkup() {
    return (
      '<div class="pp-guidance"><b>Quick dog-mom note:</b> Sudden trouble breathing, collapse, or quickly worsening signs mean call a veterinarian now. For the everyday clues in this quiz, follow the jar label and watch the clue you picked.</div>'
    );
  }

  function subscriptionUnitPriceCents() {
    return Math.round(
      CONFIG.oneTimePriceCents * (1 - CONFIG.subscriptionDiscountPercent / 100),
    );
  }

  function priceForPlan(plan, refill) {
    if (plan === "onetime" && refill.quantity === 2) return 4999;
    var unit =
      plan === "subscribe"
        ? subscriptionUnitPriceCents()
        : CONFIG.oneTimePriceCents;
    return unit * refill.quantity;
  }

  function perDayForPlan(plan, refill) {
    return Math.round(priceForPlan(plan, refill) / refill.deliveryDays);
  }

  function perDayLabel(plan, refill) {
    var total = priceForPlan(plan, refill);
    var low = Math.round(total / (60 * refill.quantity / refill.minChews));
    var high = perDayForPlan(plan, refill);
    return low === high ? money(high) : money(low) + "–" + money(high);
  }

  function durationLabel(refill, quantity) {
    var low = Math.floor(60 * quantity / refill.chewsPerDay);
    var high = Math.floor(60 * quantity / refill.minChews);
    return "Approx. " + (low === high ? low : low + "–" + high) + " days";
  }

  function compareAtMarkup(currentCents, compareCents) {
    if (!(Number(compareCents) > Number(currentCents))) return "";
    return '<span class="pp-compare">' + money(compareCents) + "</span>";
  }

  function purchaseMarkup(product, refill, recommendation) {
    var oneTimeTotal = priceForPlan("onetime", refill);
    var subscriptionTotal = priceForPlan("subscribe", refill);
    var compareTotal = refill.quantity === 2
      ? CONFIG.oneTimePriceCents * 2
      : CONFIG.compareAtPriceCents;
    var unitLabel = refill.quantity === 1 ? "1 jar" : refill.quantity + " jars";
    var campaignJar = campaignSecondJarProduct(product, recommendation, refill);
    var campaignJarMarkup = campaignJar
      ? '<label class="pp-addon" data-campaign-jar-wrap hidden><input type="checkbox" data-addon="campaignJar" data-addon-product-key="' +
        campaignJar.key +
        '" data-addon-variant-id="' +
        campaignJar.variantId +
        '"><span class="pp-addon-copy"><b>Add a second jar and use ' +
        escapeHtml(campaignCode()) +
        "</b><span>" +
        escapeHtml(campaignJar.name) +
        " · add " +
        money(CONFIG.oneTimePriceCents) +
        " now. Your cart shows the discount before checkout.</span></span>" +
        '<span class="pp-addon-price">+' +
        money(CONFIG.oneTimePriceCents) +
        "</span></label>"
      : "";
    var snuffleMatMarkup =
      '<label class="pp-addon" data-snuffle-mat-wrap><input type="checkbox" data-addon="snuffleMat" data-addon-product-key="' +
      SNUFFLE_MAT.key +
      '" data-addon-variant-id="' +
      SNUFFLE_MAT.variantId +
      '"'+(selectedAddons.snuffleMat?' checked':'')+'><img class="pp-addon-image" ' +
      responsiveImageAttributes(SNUFFLE_MAT.image,[120,240,360], "96px") +
      ' width="1254" height="1254" loading="lazy" decoding="async" alt="Premium PuzzlePup Snuffle Mat"><span class="pp-addon-copy"><b>Make it a mat + jar pair</b><span>One premium mat plus one jar is $49.99 total, with free U.S. shipping. The cart shows the discount on the jar.</span></span><span class="pp-addon-price">$49.99 total</span></label>';
    return (
      '<section class="pp-purchase" id="pp-purchase" aria-label="Buy ' +
      escapeAttribute(product.name) +
      '"><fieldset><legend>Pick what works for you</legend>' +
      '<label class="pp-plan"><input type="radio" name="pp-plan" value="onetime"' + (selectedPlan === 'onetime' ? ' checked' : '') + '><span class="pp-plan-box">' +
      '<span class="pp-plan-top"><span class="pp-plan-name">Buy it once</span><span class="pp-plan-price">' +
      money(oneTimeTotal) +
      compareAtMarkup(oneTimeTotal, compareTotal) +
      "</span></span>" +
      '<span class="pp-plan-copy">One-time · ' +
      escapeHtml(unitLabel) +
      " now · " +
      perDayLabel("onetime", refill) +
      "/day</span></span></label>" +
      '<label class="pp-plan"><input type="radio" name="pp-plan" value="subscribe"' + (selectedPlan === 'subscribe' ? ' checked' : '') + '><span class="pp-plan-box">' +
      '<span class="pp-plan-top"><span class="pp-plan-name">Send it again</span><span class="pp-plan-price">' +
      money(subscriptionTotal) +
      compareAtMarkup(subscriptionTotal, compareTotal) +
      "</span></span>" +
      '<span class="pp-plan-copy"><span class="pp-save-label">SAVE 15%</span> · ' +
      escapeHtml(unitLabel) +
      " " +
      escapeHtml(refill.cadence) +
      " · " +
      perDayLabel("subscribe", refill) +
      "/day</span></span></label>" +
      '<p class="pp-plan-help">Repeat orders are optional—change, pause, or cancel anytime.</p>' +
      "</fieldset>" +
      '<fieldset class="pp-quantity"><legend>How many jars do you want?</legend><div class="pp-quantity-grid">' +
      [1,2].map(function(q){var selected=refill.quantity===q;return '<button type="button" class="pp-choice pp-quantity-choice'+(selected?" is-selected":"")+'" data-jar-qty="'+q+'" aria-pressed="'+(selected?"true":"false")+'"><b>'+q+' jar'+(q===1?"":"s")+'</b><span>'+(q===2?"$49.99 + FREE Classic Mat · ":"")+durationLabel(refill,q)+' total</span></button>';}).join("") +
      '</div></fieldset>' +
      '<div class="pp-selected-cost" id="pp-selected-cost" aria-live="polite"></div>' +
      '<div class="pp-addons" id="pp-addons"><h4>Want one more dog-mom win?</h4>' +
      snuffleMatMarkup +
      campaignJarMarkup +
      "</div>" +
      '<button class="pp-btn" type="button" data-add-cart disabled>Add my pup’s pick</button>' +
      '<div class="pp-purchase-note">Jar duration estimate: ' +
      escapeHtml(refill.summary) +
      ". Follow your jar label: under 25 lb, 1 chew daily; 25–50 lb, 1–2; over 50 lb, 2–3. Delivery timing and jar duration may differ. Review your selected package before adding it.</div>" +
      (campaign && campaignCode()
        ? '<div class="pp-purchase-note">Discount code: <b>' +
          escapeHtml(campaignCode()) +
          "</b>. Your cart shows the savings before checkout.</div>"
        : "") +
      '<div class="pp-cart-error" id="pp-cart-error" role="alert">Ruh-roh—the cart missed that. Try once more.</div>' +
      '<div class="pp-trust"><span>🛡️ 30-day money-back promise</span><span>🔒 Secure checkout</span></div>' +
      "</section>"
    );
  }

  function proofMarkup(proof, productKey) {
    if (proof.fact) {
      return (
        '<div class="pp-proof"><h3>What’s inside—and why</h3><p>' +
        escapeHtml(proof.fact) +
        "</p><small>" +
        escapeHtml(proof.detail) +
        '</small><a data-product-link data-product-role="proof" data-product-key="' +
        productKey +
        '" href="' +
        escapeAttribute(proof.link) +
        '">' +
        escapeHtml(proof.label) +
        " →</a></div>"
      );
    }
    return (
      '<div class="pp-proof"><blockquote>“' +
      escapeHtml(proof.quote) +
      "”</blockquote><small>" +
      escapeHtml(proof.detail) +
      '</small><a data-product-link data-product-role="proof" data-product-key="' +
      productKey +
      '" href="' +
      escapeAttribute(proof.link) +
      '">' +
      escapeHtml(proof.label) +
      " →</a></div>"
    );
  }

  function faqMarkup(formula) {
    return (
      '<section class="pp-section"><div class="pp-section-title"><span aria-hidden="true">❓</span> Quick dog-mom questions</div><div class="pp-faq">' +
      formula.faq
        .concat(GENERAL_FAQ)
        .map(function (item) {
          return (
            "<details><summary>" +
            escapeHtml(item.q) +
            '</summary><div class="pp-faq-answer">' +
            escapeHtml(item.a) +
            "</div></details>"
          );
        })
        .join("") +
      "</div></section>"
    );
  }

  function bindPurchaseEvents(product, refill, recommendation) {
    stage.querySelectorAll("[data-jar-qty]").forEach(function(button){
      button.addEventListener("click",function(){
        selectedJarQuantity=Math.max(1,Math.min(2,Number(button.getAttribute("data-jar-qty"))||1));
        emit("quiz_quantity_selected",{quantity:selectedJarQuantity,product_key:product.key});
        renderResult(); bindSharedEvents();
        try{stage.querySelector("#pp-purchase").scrollIntoView({behavior:"smooth",block:"start"});}catch(error){}
      });
    });
    var campaignJar = campaignSecondJarProduct(product, recommendation, refill);
    var radios = stage.querySelectorAll('input[name="pp-plan"]');
    radios.forEach(function (radio) {
      radio.addEventListener("change", function () {
        selectedPlan = radio.value;
        if (selectedPlan === "subscribe") {
          ["campaignJar"].forEach(function (addonKey) {
            var wasSelected = Boolean(selectedAddons[addonKey]);
            selectedAddons[addonKey] = false;
            var addonCheckbox = stage.querySelector(
              '[data-addon="' + addonKey + '"]',
            );
            if (addonCheckbox) addonCheckbox.checked = false;
            if (!wasSelected) return;
            emit("quiz_order_bump_changed", {
              bump_type:
                addonKey === "campaignJar"
                  ? "campaign_second_jar"
                  : addonKey,
              selected: false,
              change_reason: "subscription_ineligible",
              plan: selectedPlan,
              primary_product_key: product.key,
              addon_product_key:
                addonKey === "campaignJar" && campaignJar
                  ? campaignJar.key
                  : null,
              addon_variant_id:
                addonKey === "campaignJar" && campaignJar
                  ? campaignJar.variantId
                  : null,
              campaign_code:
                addonKey === "campaignJar" ? campaignCode() || null : null,
            });
          });
        }
        emit(
          "quiz_plan_selected",
          Object.assign(recommendationEventData(), {
            plan: selectedPlan,
            plan_total_cents: priceForPlan(selectedPlan, refill),
            price_per_day_cents: perDayForPlan(selectedPlan, refill),
            quantity: refill.quantity,
            selling_plan_id:
              selectedPlan === "subscribe" ? refill.sellingPlanId : null,
          }),
        );
        updatePurchaseModule(product, refill, recommendation);
      });
    });

    stage.querySelectorAll("[data-addon]").forEach(function (checkbox) {
      checkbox.addEventListener("change", function () {
        var key = checkbox.getAttribute("data-addon");
        if (
          !selectedPlan ||
          (key === "campaignJar" && selectedPlan !== "onetime")
        ) {
          checkbox.checked = false;
          selectedAddons[key] = false;
          return;
        }
        selectedAddons[key] = checkbox.checked;
        emit("quiz_order_bump_changed", {
          bump_type: key === "campaignJar" ? "campaign_second_jar" : key,
          selected: checkbox.checked,
          plan: selectedPlan,
          primary_product_key: product.key,
          addon_product_key:
            checkbox.getAttribute("data-addon-product-key") || null,
          addon_variant_id:
            Number(checkbox.getAttribute("data-addon-variant-id")) || null,
          catalog_price_cents:
            key === "campaignJar"
              ? CONFIG.oneTimePriceCents
              : key === "snuffleMat"
                ? SNUFFLE_MAT.catalogPriceCents
                : 0,
          offer_price_cents:
            key === "snuffleMat" ? SNUFFLE_MAT.offerPriceCents : null,
          campaign_code: key === "campaignJar" ? campaignCode() || null : null,
        });
        updatePurchaseModule(product, refill, recommendation);
      });
    });

    stage
      .querySelector("[data-add-cart]")
      .addEventListener("click", function () {
        addPlanToCart(product, refill, recommendation);
      });
    updatePurchaseModule(product, refill, recommendation);
  }

  function updatePurchaseModule(product, refill, recommendation) {
    var addButton = stage.querySelector("[data-add-cart]");
    var addons = stage.querySelector("#pp-addons");
    var summary = stage.querySelector("#pp-selected-cost");
    var campaignJarWrap = stage.querySelector("[data-campaign-jar-wrap]");
    var snuffleMatWrap = stage.querySelector("[data-snuffle-mat-wrap]");
    if (!selectedPlan) {
      addButton.disabled = true;
      addButton.textContent = "Add my pup’s pick";
      addons.classList.remove("is-visible");
      summary.classList.remove("is-visible");
      return;
    }
    var isOneTime = selectedPlan === "onetime";
    var snuffleEligible = isOneTime && refill.quantity === 1;
    stage.querySelectorAll("[data-addon]").forEach(function (checkbox) {
      var addonKey = checkbox.getAttribute("data-addon");
      checkbox.disabled =
        (addonKey === "campaignJar" && !isOneTime) ||
        (addonKey === "snuffleMat" && !snuffleEligible);
    });
    if (!isOneTime) {
      selectedAddons.campaignJar = false;
      var campaignCheckbox = stage.querySelector('[data-addon="campaignJar"]');
      if (campaignCheckbox) campaignCheckbox.checked = false;
    }
    if (!snuffleEligible) {
      selectedAddons.snuffleMat = false;
      var snuffleCheckbox = stage.querySelector('[data-addon="snuffleMat"]');
      if (snuffleCheckbox) snuffleCheckbox.checked = false;
    }
    if (campaignJarWrap) {
      campaignJarWrap.hidden = !isOneTime;
    }
    if (snuffleMatWrap) {
      snuffleMatWrap.hidden = !snuffleEligible;
    }
    stage.querySelectorAll("[data-jar-qty]").forEach(function(button) {
      var quantity = Number(button.getAttribute("data-jar-qty"));
      var detail = button.querySelector("span");
      if (detail) detail.textContent = (isOneTime && quantity === 2 ? "$49.99 + FREE Classic Mat · " : "") + durationLabel(refill, quantity) + " total";
    });
    var base = priceForPlan(selectedPlan, refill);
    var includeCampaignJar =
      isOneTime &&
      selectedAddons.campaignJar &&
      Boolean(campaignSecondJarProduct(product, recommendation, refill));
    var includeSnuffleMat = snuffleEligible && Boolean(selectedAddons.snuffleMat);
    var extras =
      (includeCampaignJar ? CONFIG.oneTimePriceCents : 0) +
      (includeSnuffleMat ? SNUFFLE_MAT.offerPriceCents : 0);
    var total = base + extras;
    var planLabel =
      selectedPlan === "subscribe" ? "Send it again" : "Buy it once";
    summary.innerHTML =
      escapeHtml(planLabel) +
      (isOneTime && extras ? " pick" : "") +
      ": <b>" +
      money(base) +
      (selectedPlan === "subscribe"
        ? " every " + escapeHtml(refill.cadence.replace(/^every\s+/, "")) + " · "
        : extras
          ? " · "
          : " total · ") +
      perDayLabel(selectedPlan, refill) +
      "/day</b> for " +
      refill.quantity +
      " jar" +
      (refill.quantity === 1 ? "" : "s") +
      "." +
      (extras
        ? " Your cart before any code: <b>" +
          money(total) +
          (includeCampaignJar ? " with your $49.99 pair" : "") +
          (includeSnuffleMat ? " for your mat + jar pair" : "") +
          ".</b>"
        : "");
    summary.classList.add("is-visible");
    if (snuffleEligible || (isOneTime && campaignJarWrap))
      addons.classList.add("is-visible");
    else addons.classList.remove("is-visible");
    addButton.disabled = false;
    var ctaLabel =
      selectedPlan === "subscribe" ? "Keep " + product.name + " coming" : "Get " + product.name;
    if (includeCampaignJar) ctaLabel += " + second jar";
    if (includeSnuffleMat) ctaLabel += " + Snuffle Mat";
    addButton.textContent =
      ctaLabel +
      " · " +
      money(total) +
      (includeCampaignJar ? " with your $49.99 pair" : "") +
      (includeSnuffleMat ? " for your mat + jar pair" : "");
  }

  function cartSnapshot(product, refill, recommendation) {
    var plan = selectedPlan;
    var campaignJarProduct = campaignSecondJarProduct(
      product,
      recommendation,
      refill,
    );
    var campaignSnapshot = campaign
      ? Object.freeze({
          active: true,
          code: campaignCode(),
          headline: String(campaign.headline || ""),
          eligibility: String(campaign.eligibility || ""),
          destination: String(campaign.destination || ""),
        })
      : null;
    var campaignSecondJarSelected =
      plan === "onetime" &&
      Boolean(selectedAddons.campaignJar) &&
      Boolean(campaignJarProduct);
    var snuffleMatSelected = Boolean(selectedAddons.snuffleMat);
    return Object.freeze({
      plan: plan,
      primaryProductKey: product.key,
      primaryVariantId: product.variantId,
      baseQuantity: refill.quantity,
      sellingPlanId: plan === "subscribe" ? refill.sellingPlanId : null,
      campaignSecondJar: campaignSecondJarSelected,
      campaignJar: campaignJarProduct
        ? Object.freeze({
            key: campaignJarProduct.key,
            name: campaignJarProduct.name,
            variantId: campaignJarProduct.variantId,
          })
        : null,
      snuffleMat: snuffleMatSelected,
      snuffleMatProduct: snuffleMatSelected
        ? Object.freeze({
            key: SNUFFLE_MAT.key,
            name: SNUFFLE_MAT.name,
            variantId: SNUFFLE_MAT.variantId,
            catalogPriceCents: SNUFFLE_MAT.catalogPriceCents,
            offerPriceCents: SNUFFLE_MAT.offerPriceCents,
          })
        : null,
      campaign: campaignSnapshot,
      campaignEligible:
        Boolean(campaignSnapshot) &&
        plan === "onetime" &&
        (refill.quantity >= 2 || campaignSecondJarSelected),
    });
  }

  function cartEventPayload(snapshot, refill, items, preDiscountTotalCents) {
    return {
      plan: snapshot.plan,
      primary_variant_id: snapshot.primaryVariantId,
      quantity: snapshot.baseQuantity,
      selling_plan_id: snapshot.sellingPlanId,
      campaign_second_jar: snapshot.campaignSecondJar,
      campaign_second_jar_product_key:
        snapshot.campaignSecondJar && snapshot.campaignJar
          ? snapshot.campaignJar.key
          : null,
      campaign_second_jar_variant_id:
        snapshot.campaignSecondJar && snapshot.campaignJar
          ? snapshot.campaignJar.variantId
          : null,
      campaign_code:
        snapshot.campaignEligible && snapshot.campaign
          ? snapshot.campaign.code
          : null,
      active_campaign_code: snapshot.campaign
        ? snapshot.campaign.code
        : null,
      campaign_eligible: snapshot.campaignEligible,
      campaign_destination: snapshot.campaign
        ? snapshot.campaign.destination || null
        : null,
      snuffle_mat_selected: snapshot.snuffleMat,
      snuffle_mat_variant_id:
        snapshot.snuffleMat && snapshot.snuffleMatProduct
          ? snapshot.snuffleMatProduct.variantId
          : null,
      snuffle_mat_catalog_price_cents:
        snapshot.snuffleMat && snapshot.snuffleMatProduct
          ? snapshot.snuffleMatProduct.catalogPriceCents
          : null,
      snuffle_mat_offer_price_cents:
        snapshot.snuffleMat && snapshot.snuffleMatProduct
          ? snapshot.snuffleMatProduct.offerPriceCents
          : null,
      pre_discount_total_cents: preDiscountTotalCents,
      item_count: items.length,
      cart_total_quantity: items.reduce(function (total, item) {
        return total + Number(item.quantity || 0);
      }, 0),
      refill_cadence: refill.cadence,
    };
  }

  function addPlanToCart(product, refill, recommendation) {
    if (!selectedPlan) return;
    var button = stage.querySelector("[data-add-cart]");
    var errorBox = stage.querySelector("#pp-cart-error");
    var originalLabel = button.textContent;
    var controls = Array.prototype.slice.call(
      stage.querySelectorAll('input[name="pp-plan"], [data-addon]'),
    );
    var priorControlStates = controls.map(function (control) {
      return { control: control, disabled: control.disabled };
    });
    var snapshot = cartSnapshot(product, refill, recommendation);

    function restoreControls() {
      priorControlStates.forEach(function (state) {
        state.control.disabled = state.disabled;
      });
      button.disabled = false;
      button.removeAttribute("aria-busy");
      button.textContent = originalLabel;
    }

    controls.forEach(function (control) {
      control.disabled = true;
    });
    button.disabled = true;
    button.setAttribute("aria-busy", "true");
    button.textContent = "Adding…";
    errorBox.classList.remove("is-visible");

    var primaryItem = {
      id: snapshot.primaryVariantId,
      quantity: snapshot.baseQuantity,
    };
    if (snapshot.plan === "subscribe") {
      primaryItem.selling_plan = snapshot.sellingPlanId;
    }
    var items = [primaryItem];
    if (snapshot.campaignSecondJar && snapshot.campaignJar) {
      if (snapshot.campaignJar.variantId === primaryItem.id)
        primaryItem.quantity += 1;
      else items.push({ id: snapshot.campaignJar.variantId, quantity: 1 });
    }
    if (snapshot.snuffleMat && snapshot.snuffleMatProduct) {
      items.push({ id: snapshot.snuffleMatProduct.variantId, quantity: 1 });
    }
    var preDiscountTotalCents =
      priceForPlan(snapshot.plan, refill) +
      (snapshot.campaignSecondJar ? CONFIG.oneTimePriceCents : 0) +
      (snapshot.snuffleMat && snapshot.snuffleMatProduct
        ? snapshot.snuffleMatProduct.offerPriceCents
        : 0);
    var eventPayload = cartEventPayload(
      snapshot,
      refill,
      items,
      preDiscountTotalCents,
    );

    emit(
      "quiz_add_to_cart",
      Object.assign(recommendationEventData(), {
        status: "attempt",
      }, eventPayload),
    );

    if (internalQaInfo.value) {
      var qaPayload = {
        recordedAt: new Date().toISOString(),
        endpoint: "/cart/add.js",
        request: { items: JSON.parse(JSON.stringify(items)) },
        snapshot: {
          plan: snapshot.plan,
          campaignSecondJar: snapshot.campaignSecondJar,
          campaignEligible: snapshot.campaignEligible,
          campaignJar: snapshot.campaignJar,
          campaign: snapshot.campaign,
          snuffleMat: snapshot.snuffleMat,
          snuffleMatProduct: snapshot.snuffleMatProduct,
        },
        analytics: eventPayload,
      };
      publicApi.lastQaCartPayload = qaPayload;
      publicApi.qaCartPayloads.push(qaPayload);
      emit(
        "quiz_add_to_cart_dry_run",
        Object.assign(recommendationEventData(), eventPayload, {
          status: "dry_run",
          cart_api_called: false,
        }),
      );
      restoreControls();
      button.textContent = "QA dry run saved · cart unchanged";
      return;
    }

    Promise.resolve()
      .then(function () {
        return window.fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ items: items }),
        });
      })
      .then(function (response) {
        if (!response.ok) {
          return response.text().then(function (body) {
            throw new Error(
              "Cart add failed (" +
                response.status +
                "): " +
                body.slice(0, 120),
            );
          });
        }
        return response.json();
      })
      .then(function () {
        emit(
          "quiz_add_to_cart_success",
          Object.assign(recommendationEventData(), eventPayload, {
            status: "success",
          }),
        );
        return applyActiveCampaignIfEligible(snapshot);
      })
      .then(function () {
        if (window.PuzzlePupStorefront && typeof window.PuzzlePupStorefront.refreshCartSurfaces === "function") {
          return window.PuzzlePupStorefront.refreshCartSurfaces().then(function () {
            if (!window.PuzzlePupStorefront.openCartDrawer()) {
              window.location.assign((window.Shopify?.routes?.root || "/") + "cart");
            }
          }).catch(function () {
            window.location.assign((window.Shopify?.routes?.root || "/") + "cart");
          });
        }
        document.dispatchEvent(new CustomEvent("pp:cart-updated"));
        var nativeDrawer = document.querySelector("cart-drawer");
        if (nativeDrawer && typeof nativeDrawer.open === "function") {
          nativeDrawer.open();
          return;
        }
        var funnelDrawer = document.querySelector("[data-pp-funnel-drawer]");
        if (funnelDrawer && window.PuzzlePupFunnelDrawer && typeof window.PuzzlePupFunnelDrawer.open === "function") {
          window.PuzzlePupFunnelDrawer.open();
          return;
        }
        window.location.assign((window.Shopify?.routes?.root || "/") + "cart");
      })
      .catch(function (error) {
        restoreControls();
        errorBox.textContent =
          "Ruh-roh—the cart missed that. Try once more, or open the jar page.";
        errorBox.classList.add("is-visible");
        emit(
          "quiz_error",
          Object.assign(recommendationEventData(), {
            error_stage: "add_to_cart",
            error_message: String(
              error && error.message ? error.message : "cart error",
            ).slice(0, 180),
            plan: snapshot.plan,
            primary_variant_id: snapshot.primaryVariantId,
          }),
        );
      })
      .finally(restoreControls);
  }

  function applyActiveCampaignIfEligible(snapshot) {
    return Promise.resolve();
  }

  function bindRetake() {
    var button = stage.querySelector("[data-retake]");
    if (!button) return;
    button.addEventListener("click", function () {
      emit("quiz_retake", recommendationEventData());
      try {
        localStorage.removeItem(storageKey);
      } catch (error) {}
      answers = {
        goal: entryGoal || "", details: [], weight: null, weightBand: "", exactWeight: "", approach: "", signal: "",
        pattern: "", impact: "", dogName: "", email: "", breed: "", gender: "", age: "", ageYears: "", ageMonths: "", ageUnknown: false, showExactWeight: false,
        dental: [], skin: [], allergy: [], gut: [], mobility: [], emailStatus: "not_seen", emailConsent: false
      };
      selectedJarQuantity = 2;
      selectedPlan = null;
      selectedAddons = { campaignJar: false, snuffleMat: false };
      selectedResultProductKey = null;
      selectedPackageOpen = false;
      resultTracked = false;
      attemptId = createId("attempt");
      setScreen("intro");
    });
  }
})();
